import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { MotivoMedidaViewModel, Tc, TcPerfilUsuarioEnum, WOrganismosNocivosExtendedViewModel } from '../../../core/_infrastructure/types/common';
import { AsyncInfoService } from '../../../core/components/asyncInfo/asyncInfo.service';
import { AsyncInfoRequestViewModel, AsyncInfoResponseViewModel } from '../../../core/components/asyncInfo/asyncInfo.types';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { OrganismosNocivosPopupComponent } from '../../../core/components/popup/organismosnocivos/organismosNocivosPopup.component';
import { DocumentUploaderService } from '../../../core/components/uploader/document-uploader.service';
import { UploadedFileViewModel } from '../../../core/components/uploader/document_uploader.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { DocumentosService } from '../documentos/documentos.service';
import { SolicitudDocumentosViewModel, TDocumentoSolicitudViewModel } from '../documentos/documentos.types';
import { PreduaService } from '../predua/predua.service';
import { TPosicionamientoPreduaViewModel } from '../predua/predua.types';
import { SolicitudProductosViewModel, TProductoSolicitudViewModel, TwEmbalajesViewModel } from '../productos/productos.types';
import {
    EnumCodigosTwTcAcciones,
    EnumIdsTcEstadoSolicitud,
    EnumIdsTcTipoPuntoInspeccion,
    EnumIdsTcTipoSolicitud,
    EnumIdsTwTcDecisionInspeccion,
    EnumIdsTwTcTipoClonacion,
    EnumIdsEstadoChedPP,
    EnumIdsTwTcDecisionInspeccionLetter,
    EnumIdsTwTcMedidaRechazo,
    EnumIdsTcSeccionSeguimiento,
} from '../types/enum';
import { InspeccionesService } from './inspecciones.service';
import {
    InspeccionSubmitPostRequest,
    TInspeccionViewModel,
    TwEmbalajeRechazoMedida,
    TwEmbalajeRechazoMotivo,
    TwInspeccionRechazoViewModel,
    TwProductoRechazoMedida,
    TwProductoRechazoMotivo,
    TwSolicitudFrSanidadExtViewModel,
    TwSolicitudFrViewModel,
    TwSolicitudMedidaRechazoViewModel,
    TwSolicitudMotivoRechazoViewModel,
} from './inspecciones.types';
import { InformesService } from 'src/app/components/_mantenimiento/informes/informes.service';
import { SolicitudViewModel } from '../datosbasicos/datosbasicos.types';
import { TComentarioInspectorViewModel } from '../seguimiento/seguimiento.types';
import { SeguimientoService } from '../seguimiento/seguimiento.service';
import { Subject, Subscription } from 'rxjs';

@Component({
    selector: 'app-inspecciones',
    templateUrl: './inspecciones.component.html',
    styleUrls: ['./inspecciones.component.scss'],
})
export class InspeccionesComponent extends ComponentBase implements OnInit, OnDestroy {
    //@ViewChild(DestinoControlPopupComponent)
    //private destinoControlPopupComponent: DestinoControlPopupComponent;

    @ViewChild(OrganismosNocivosPopupComponent)
    private organismoNocivoPopupComponent: OrganismosNocivosPopupComponent;

    private solicitud: SolicitudViewModel;
    private solicitudCargada$: Subject<boolean>; // Se lanzará un evento cuando la solicitud esté cargada
    private subscription: Subscription;
    private solicitud$: Subscription;

    inspeccion: TInspeccionViewModel;
    solicitudEquipamientos: SolicitudProductosViewModel;
    habilitarGuardar = false;
    habilitarEdicion = false;
    habilitarNuevoSeguimiento = false;
    IdSolicitud: number;
    IdInspector: number;
    IdEstadoSolicitud: number;
    IdResultadoEnvioMuestrasLaboratorio: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    labelDocumental = '';
    labelIdentidad = '';
    labelFisica = '';
    labelApto = 'APTO';
    labelNoApto = 'NO APTO';

    habilitarAceptarDecision = false;
    habilitarRechazarDecision = false;
    editMode = false;
    matriculasInsp: any[];
    posicionamientopredua: TPosicionamientoPreduaViewModel[];
    EsPredua = false;
    EsReImportacion = false;
    EsTraslado: boolean;
    EsAeropuerto: boolean;
    Documental: boolean | null = null;
    Identidad: boolean | null = null;
    Fisica: boolean | null = null;
    SeEfectuaIdentidadFisica = false;
    mostrarMensajePredua = false;
    IdTipoSolicitud: number;
    IdEstadoChedPp: number | null;
    IdEstadoChedPpDescripcion: string;
    tituloTipoSolicitud: string;
    tituloEstadoSolicitud: string;
    codigoTipoSolicitud: string;
    CodigoSolicitud: string;
    visibilitySpinner = false;
    esClonada = false;
    esInspector = false;
    esSolicitante = false;
    FechaLlegada: Date;
    fechaFinalizacion: string | null = null;
    visibilityDecision = false;
    visibilityMedidasRechazos = false;
    visibilityDocumentos = false;
    visibilityTableHeaderCheckbox = true;
    visibilityNoProcede = false;
    visibilityMensajeNoProcede = false;
    labelNoProcede = 'No Procede';
    numeroProductos = 0;

    listMedidasRechazo: MotivoMedidaViewModel[];
    listAlcancesRechazo: Tc[];
    listPaisCuarentena: Tc[];

    listMotivosRechazo: Tc[];
    listDetallesMotivoRechazo: MotivoMedidaViewModel[];
    listElementosRechazo: Tc[] = [];
    listGradoContaminacion: Tc[] = [];
    listOrganismoNocivoNoReguladoUE: Tc[] = [];
    listOrganismoNocivoNoEspecie: Tc[] = [];

    listElementosRechazo$ = this.globalService.getElementosRechazo().subscribe(result => {
        this.listElementosRechazo = result;
    });

    //cargar combos de productos y embalajes para motivos y medidas del rechazo
    listProductosSolicitud: TProductoSolicitudViewModel[];
    listEmbalajesSolicitud: TwEmbalajesViewModel[];

    //recogen los productos y embalajes que se seleccionan en los combos para las medidas y los motivos del rechazo
    listProductosMedidaRechazoSeleccionados: TProductoSolicitudViewModel[] = [];
    listEmbalajesMedidaRechazoSeleccionados: TwEmbalajesViewModel[] = [];
    listProductosMotivoRechazoSeleccionados: TProductoSolicitudViewModel[] = [];
    listEmbalajesMotivoRechazoSeleccionados: TwEmbalajesViewModel[] = [];

    IdDestinoControl: number | null;
    destinoControlObligatorio: false;
    colsMedidas: any[];
    colsMotivos: any[];
    labelAceptar = 'Aceptar';
    colsObservaciones: any[];
    TComentarioInspectorCollection: TComentarioInspectorViewModel[];
    enumDecisionLetter = EnumIdsTwTcDecisionInspeccionLetter;
    DESCRIPCION_NO_APTO_POR_HIGIENE = '';
    private DESCRIPCION_DECISION_NO_APTO_POR_HIGIENE_DEFAULT = 'No apto por Higiene';

    requerirObservaciones: boolean | null = false;

    //RDLF:25/10/24 eliminar estas validaciones (tarea 144306)
    //requerirIdentidad: boolean | null = false;
    //requerirFisica: boolean | null = false;
    //es obligatorio informar el producto o el embalaje tanto en motivo como en medida
    requerirProductoMotivo: boolean | null = true;
    requerirEmbalajeMotivo: boolean | null = false;
    requerirProductoMedida: boolean | null = true;
    requerirEmbalajeMedida: boolean | null = false;

    visualizarCamposDeOrganismosNocivos = false;
    esOrganismoNocivo_No_ReguladoUE = false;
    esOrganismoNocivo_No_Especie = false;
    idOrganismoNocivo: number | null;
    esMedidaCuarentena = false;
    //detalles de motivo que, si se seleccionan, harán que se solicite al usuario que indique el organismo nocivo
    arrayCodigosTracesParaDetalleMotivoOrganismoNocivo = ['PRESENCE_OF_UNION_QP_OR_PZQP', 'PRESENCE_OF_RNQP'];

    //documentos
    isCollapsedDocumentos = false;
    mostrarDocumentosModoEdicion = false;
    numeroDocumentos = 0;
    solicitudDocumento: SolicitudDocumentosViewModel; //para la llamada al servicio que carga los documentos de una solicitud
    documentos: TDocumentoSolicitudViewModel[]; //documentos para el grid. Se alimenta de uno de estos orígenes: solicitudDocumento (si hubo que llamar al servicio de documentos) o this.inpseccion si ya había inspección
    colsDocumentos: any[];
    uploadedFile: UploadedFileViewModel;
    documentosAttachedRechazoUserCheck: number[] = []; //guarda los Id de los documentos que el usuario marca para adjuntar al rechazo
    documentosAttachedRechazoBDChecked: TDocumentoSolicitudViewModel[]; //guarda los Id de los documentos que están guardados en BD como adjuntados al rechazo
    inspeccionSubmitPostRequest: InspeccionSubmitPostRequest;
    strTituloMarcarDocumentosAdjuntos = 'Documentos: Marque aquellos que quiera adjuntar al rechazo';
    strTituloMarcadosDocumentosAdjuntos = 'Documentos: se listan a continuación los adjuntados al rechazo';
    tituloDocumentosAdjuntos = this.strTituloMarcarDocumentosAdjuntos;

    //FR
    mostrarFrecuenciaReducida = false;
    mostrarFrSanidadExt = false;
    colsFrecRed: any[];
    frInsp: TwSolicitudFrViewModel[];
    frSanidadExtInsp: TwSolicitudFrSanidadExtViewModel[];

    //Rechazo Parcial (División solicitudes)
    canRechazoParcial = false;
    visibilityMsgRechazoParcial = false;
    visibilityBtnRechazoParcial = false;
    esClonParticion = false;
    esRechazoParcial = false;

    private listDecisionesInspeccion: Tc[];

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private inspeccionesService: InspeccionesService,
        private informesService: InformesService,
        private seguimientoService: SeguimientoService,
        private documentosService: DocumentosService,
        private uploaderService: DocumentUploaderService,
        private navMenuService: NavMenuService,
        private globalService: GlobalService,
        private solicitudService: SolicitudService,
        private preduaService: PreduaService,
        protected asyncInfoService: AsyncInfoService,
        private confirmationService: ConfirmationService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.inspeccion = new TInspeccionViewModel();
        this.solicitudDocumento = new SolicitudDocumentosViewModel();
    }

    ngOnInit() {
        this.Init(true);
        this.form.controls['SeEfectuaIdentidadFisica'].disable();
        this.form.controls['Identidad'].disable();
        this.form.controls['Fisica'].disable();
    }

    private sincronizarFrSanidadExtConSolicitud(): void {
        this.solicitudCargada$ = new Subject<boolean>();
        this.subscription = this.solicitudCargada$.subscribe(res => {
            this.subscription.unsubscribe(); // Así evitamos que se subscriba otra vez, cuando al "guardar" se invoca a ngOnInit.
            if (res) {
                this.CargarFRSanidadExt();
            }
        });
    }

    private Init(refreshPage: boolean) {
        this.sincronizarFrSanidadExtConSolicitud();
        this.CreateColsFrecuencia();
        this.CreateColsMedidas();
        this.CreateColsMotivos();
        this.CreateColsSeguimientos();

        this.IdSolicitud = +this.activatedRoute.snapshot.params['id'];

        this.IdInspector = this.loggedInUser!.Id;
        this.esInspector = this.isInspector;
        this.esSolicitante = this.isSolicitante;

        if (refreshPage) {
            this.loadSolicitudById(this.IdSolicitud);
        } else {
            this.solicitudCargada$?.next(true);
        }

        this.createForm();

        //Siempre tendrá un idSolicitud
        if (this.IdSolicitud) {
            this.loading = true;

            //Cargamos FR
            this.CargarFR();
            // La carga de FR Higiene, depende de que se haya cargado primero el objeto Solicitud. Ver método: "sincronizarFrSanidadExtConSolicitud"

            //recuperar la inspeccion
            this.inspeccionesService.getInspeccion(this.IdSolicitud).subscribe({
                next: result => {
                    this.handlerInspeccion(result);
                },
                error: error => {
                    this.catchServerError(error);
                },
            });

            this.loading = false;
        }

        this.loadDecisionesInspeccion();
    }

    private loadDecisionesInspeccion(): void {
        this.informesService.getDecisionInspeccion().subscribe(res => {
            this.listDecisionesInspeccion = res;
            if (this.listDecisionesInspeccion) {
                this.DESCRIPCION_NO_APTO_POR_HIGIENE =
                    this.listDecisionesInspeccion.find(decision => decision.Id === EnumIdsTwTcDecisionInspeccion.NO_APTO_POR_HIGIENE)?.Descripcion ||
                    this.DESCRIPCION_DECISION_NO_APTO_POR_HIGIENE_DEFAULT;
            }
        });
    }

    private CreateColsFrecuencia() {
        this.colsFrecRed = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdSolicitud', header: 'IdSolicitud', display: 'none' },
            { field: 'GrupoFrDescripcion', header: 'Grupo FR' },
            { field: 'Frecuencia', header: '% Frecuencia' },
            { field: 'PorcentajePif', header: '% PIF' },
            { field: 'PorcentajeNacional', header: '% Nacional' },
        ];
    }

    private CreateColsSeguimientos() {
        this.colsObservaciones = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'Observaciones', header: 'Descripción' },
            { field: 'Inspector', header: 'Inspector' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdSeccionDescripcion', header: 'Seccion' },
            { field: 'IdMotivoDescripcion', header: 'Motivo' },
        ];
    }

    private CreateColsMotivos() {
        this.colsMotivos = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdMotivoRechazoDescripcion', header: 'Motivo' },
            {
                field: 'IdDetalleMotivoRechazoDescripcion',
                header: 'Detalle del Motivo',
            },
            { field: 'IdElementoRechazoDescripcion', header: 'Elemento' },
            {
                field: 'IdProductoMotivoRechazoDescripcion',
                header: 'Productos',
            },
            {
                field: 'IdEmbalajeMotivoRechazoDescripcion',
                header: 'Embalajes',
            },
            {
                field: 'IdOrganismoNocivoDescripcion',
                header: 'Organismo Nocivo',
            },
            {
                field: 'IdGradoContaminacionDescripcion',
                header: 'Grado Contaminación',
            },
            {
                field: 'IdOrganismoNocivoNoReguladoUEDescripcion',
                header: 'Organismo Nocivo No Regulado UE',
            },
            {
                field: 'IdOrganismoNocivoNoEspecieDescripcion',
                header: 'Organismo Nocivo No Especie',
            },
            { field: 'ObservacionesMotivosRechazo', header: 'Observaciones' },
        ];
    }

    private CreateColsMedidas() {
        this.colsMedidas = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdMedidaRechazoDescripcion', header: 'Medida' },
            { field: 'IdAlcanceRechazoDescripcion', header: 'Alcance' },
            {
                field: 'IdProductoMedidaRechazoDescripcion',
                header: 'Productos',
            },
            {
                field: 'IdEmbalajeMedidaRechazoDescripcion',
                header: 'Embalajes',
            },
            {
                field: 'FechaComienzoCuarentena',
                header: 'Fec. Comienzo Cuarentena',
            },
            {
                field: 'FechaTerminacionPrevistaCuarentena',
                header: 'Fec. Terminación Prevista Cuarentena',
            },
            {
                field: 'FechaTerminacionCuarentena',
                header: 'Fec. Terminación Cuarentena',
            },
            {
                field: 'IdPaisCuarentenaDescripcion',
                header: 'País de Cuarentena',
            },
            { field: 'LugarCuarentena', header: 'Lugar de Cuarentena' },
        ];
    }

    private handlerInspeccion(result: TInspeccionViewModel): void {
        if (result) {
            // HAY INSPECCIÓN
            this.handlerHayInspeccion(result);
        } else {
            // NO HAY INSPECCIÓN
            this.handlerNoHayInspeccion();
        }
    }

    private handlerHayInspeccion(result: TInspeccionViewModel): void {
        this.inspeccion = result;

        this.editMode = true;

        this.IdTipoSolicitud = this.inspeccion.IdTipoSolicitud;
        this.IdEstadoSolicitud = this.inspeccion.IdEstadoSolicitud;
        this.IdResultadoEnvioMuestrasLaboratorio = this.inspeccion.IdResultadoEnvioMuestrasLaboratorio;
        this.DescripcionIdResultadoEnvioMuestrasLaboratorio = this.inspeccion.DescripcionIdResultadoEnvioMuestrasLaboratorio;
        this.EsPredua = this.inspeccion.EsPredua;
        this.EsReImportacion = this.inspeccion.EsReImportacion;
        this.EsTraslado = this.inspeccion.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRASLADO ? true : false;
        this.EsAeropuerto = this.inspeccion.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO ? true : false;
        this.tituloTipoSolicitud = this.inspeccion.IdTipoSolicitudDescripcion;
        this.IdEstadoChedPp = this.inspeccion.IdEstadoChedPp;
        this.IdEstadoChedPpDescripcion = this.inspeccion.IdEstadoChedPpDescripcion;
        this.esRechazoParcial = this.inspeccion.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE;
        this.esClonada =
            this.inspeccion.TwSolicitudJerarquia != null && this.inspeccion.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                ? true
                : false;
        this.esClonParticion =
            this.inspeccion.TwSolicitudJerarquia != null && this.inspeccion.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_PARTICION
                ? true
                : false;
        this.FechaLlegada = this.inspeccion.FechaLlegada;
        this.IdDestinoControl = this.inspeccion.TwInspeccionRechazo != null ? this.inspeccion.TwInspeccionRechazo.IdDestinoControl : null;
        this.numeroProductos = this.inspeccion.TProductoSolicitudCollection.length;
        //this.fechaFinalizacion = this.inspeccion.FechaFinalizacion;
        this.fechaFinalizacion = this.datepipe.transform(result.FechaFinalizacion, 'dd/MM/yyyy HH:mm:ss');
        //SI ES RE-IMPORTACION
        if (this.EsReImportacion) {
            this.tituloTipoSolicitud += ' - Re-Importación';
        }
        //SI ES PREVIA
        if (this.inspeccion.EsPrevia) {
            if (
                this.inspeccion.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                this.inspeccion.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
            ) {
                this.tituloTipoSolicitud += ' - Previa';
            }
        }
        this.codigoTipoSolicitud = this.inspeccion.CodigoTipoSolicitud;
        this.tituloEstadoSolicitud = this.inspeccion.IdEstadoSolicitudDescripcion;
        this.CodigoSolicitud = this.inspeccion.CodigoSolicitud;
        this.visibilityNoProcede = this.EsPredua && this.numeroProductos == 1 && this.Documental != null;

        this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_INSPECCION, this.IdEstadoSolicitud).Visible; //RDLF:(comentado por problemas con algunos permisos,'rechazadoTraces' es editable) //&& this.fechaFinalizacion === null;
        this.habilitarEdicion =
            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_INSPECCIONES, this.IdEstadoSolicitud).Editable &&
            this.inspeccion.IdDecision != EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE; //RDLF:(comentado por problemas con algunos permisos,'rechazadoTraces' es editable)// && this.fechaFinalizacion === null;

        this.habilitarNuevoSeguimiento = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO, this.IdEstadoSolicitud).Editable;

        if (this.inspeccion.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO) {
            this.labelAceptar = 'Autorizar para el tránsito';
        }

        if (this.esSolicitante) {
            this.TComentarioInspectorCollection = this.inspeccion.TComentarioInspectorCollection.filter(
                t => t.VisibleSolicitante && t.IdSeccion == EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES,
            );
        } else {
            this.TComentarioInspectorCollection = this.inspeccion.TComentarioInspectorCollection.filter(
                t => t.IdSeccion == EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES,
            );
        }
        //RDLF: 23 / 10 / 24 de momento los preduas cargan los equipamientos igual que los no preduas(144302)
        //if (this.EsPredua) {
        //    //recuperar matrí­culas PosicionamientoPredua
        //    this.preduaService.getPosicionamientoPredua(this.inspeccion.Mrn).subscribe(resultPosicionamiento => {
        //        this.posicionamientopredua = resultPosicionamiento;
        //    });
        //}
        //else {
        this.matriculasInsp = this.inspeccion.TSolicitudEquipamientoCollection;

        this.matriculasInsp.map((o, i) => {
            const control = new UntypedFormControl(o.Inspeccion); // if first item set to true, else false
            (this.form.controls.matriculasInsp as UntypedFormArray).push(control);
        });
        //}

        this.updateForm();

        if (this.esInspector) {
            this.canRechazoParcial =
                (!this.esClonParticion &&
                    this.numeroProductos > 1 &&
                    !this.EsTraslado &&
                    this.habilitarEdicion &&
                    this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.RADIOBUTTON_RECHAZO_PARCIAL).Visible) ||
                this.inspeccion.IdDecision == EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE;
        } else {
            this.canRechazoParcial =
                (!this.esClonParticion && this.numeroProductos > 1 && this.habilitarEdicion && !this.EsTraslado) ||
                this.inspeccion.IdDecision == EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE;
        }

        this.gestionarVisibilidadDecision();

        this.gestionarRechazo();

        if (!this.habilitarEdicion) {
            //metodo para deshabilitar los controles
            this.DisableControlsConsulta();
        }

        this.visibilityBtnRechazoParcial =
            this.inspeccion.IdDecision == EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE &&
            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.VER_RECHAZO_PARCIAL, this.IdEstadoSolicitud).Editable;
    }

    private handlerNoHayInspeccion(): void {
        this.editMode = false;
        //cargo los equipamientos
        this.inspeccionesService.getEquipamientos(this.IdSolicitud).subscribe({
            next: result => {
                this.handlerEquipamientos(result);
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    private handlerEquipamientos(result: SolicitudProductosViewModel): void {
        this.solicitudEquipamientos = result;

        this.IdTipoSolicitud = this.solicitudEquipamientos.IdTipoSolicitud;
        this.IdEstadoSolicitud = this.solicitudEquipamientos.IdEstadoSolicitud;
        this.IdResultadoEnvioMuestrasLaboratorio = this.solicitudEquipamientos.IdResultadoEnvioMuestrasLaboratorio;
        this.DescripcionIdResultadoEnvioMuestrasLaboratorio = this.solicitudEquipamientos.DescripcionIdResultadoEnvioMuestrasLaboratorio;
        this.EsPredua = this.solicitudEquipamientos.EsPredua;
        this.EsReImportacion = this.solicitudEquipamientos.EsReImportacion;
        this.EsTraslado = this.solicitudEquipamientos.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRASLADO ? true : false;
        this.EsAeropuerto = this.solicitudEquipamientos.TPuntoInspeccion.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO ? true : false;
        this.tituloTipoSolicitud = this.solicitudEquipamientos.TcTipoSolicitud.Descripcion;
        this.IdEstadoChedPp = this.solicitudEquipamientos.IdEstadoChedPp;
        this.IdEstadoChedPpDescripcion = this.solicitudEquipamientos.IdEstadoChedPpDescripcion;
        this.esRechazoParcial = this.solicitudEquipamientos.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_RECHAZADA_PARCIALMENTE;

        this.esClonada =
            this.solicitudEquipamientos.TwSolicitudJerarquia != null &&
            this.solicitudEquipamientos.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                ? true
                : false;
        this.esClonParticion =
            this.solicitudEquipamientos.TwSolicitudJerarquia != null &&
            this.solicitudEquipamientos.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_PARTICION
                ? true
                : false;
        this.FechaLlegada = this.solicitudEquipamientos.FechaLlegada;
        this.numeroProductos = this.solicitudEquipamientos.TProductoSolicitudCollection.length;
        //SI ES RE-IMPORTACION
        if (this.EsReImportacion) {
            this.tituloTipoSolicitud += ' - Re-Importación';
        }
        //SI ES PREVIA
        if (this.solicitudEquipamientos.EsPrevia) {
            if (
                this.solicitudEquipamientos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                this.solicitudEquipamientos.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
            ) {
                this.tituloTipoSolicitud += ' - Previa';
            }
        }
        this.codigoTipoSolicitud = this.solicitudEquipamientos.TcTipoSolicitud.Codigo;
        this.tituloEstadoSolicitud = this.solicitudEquipamientos.TcEstadoSolicitud.Descripcion;
        this.CodigoSolicitud = this.solicitudEquipamientos.CodigoSolicitud;
        this.visibilityNoProcede = this.EsPredua && this.numeroProductos == 1 && this.Documental != null;

        this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_INSPECCION, this.IdEstadoSolicitud).Visible; //RDLF:(comentado por problemas con algunos permisos,'rechazadoTraces' es editable) && this.fechaFinalizacion === null;
        this.habilitarEdicion = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_INSPECCIONES, this.IdEstadoSolicitud).Editable; //RDLF:(comentado por problemas con algunos permisos,'rechazadoTraces' es editable) && this.fechaFinalizacion === null;

        this.habilitarNuevoSeguimiento = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO, this.IdEstadoSolicitud).Editable;

        if (this.esInspector) {
            this.canRechazoParcial =
                !this.esClonParticion &&
                !this.EsTraslado &&
                this.numeroProductos > 1 &&
                this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.RADIOBUTTON_RECHAZO_PARCIAL).Visible;
        } else {
            this.canRechazoParcial = !this.esClonParticion && this.numeroProductos > 1 && !this.EsTraslado;
        }

        if (this.esSolicitante) {
            this.TComentarioInspectorCollection = this.solicitudEquipamientos.TComentarioInspectorCollection.filter(
                t => t.VisibleSolicitante && t.IdSeccion == EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES,
            );
        } else {
            this.TComentarioInspectorCollection = this.solicitudEquipamientos.TComentarioInspectorCollection.filter(
                t => t.IdSeccion == EnumIdsTcSeccionSeguimiento.ID_INSPECCIONES,
            );
        }

        this.gestionarVisibilidadDecision();

        if (!this.habilitarEdicion) {
            //metodo para deshabilitar los controles
            this.DisableControlsConsulta();
        }

        if (this.solicitudEquipamientos.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO) {
            this.labelAceptar = 'Autorizar para el tránsito';
        }

        if (this.EsPredua) {
            this.form.controls['Identidad'].disable();
            this.form.controls['Fisica'].disable();

            //RDLF: 23/10/24 de momento los preduas cargan los equipamientos igual que los no preduas (144302)
            //recuperar matrí­culas PosicionamientoPredua
            //this.preduaService.getPosicionamientoPredua(this.solicitudEquipamientos.TMedioTransporte.Mrn).subscribe(resultPosicionamiento => {
            //    this.posicionamientopredua = resultPosicionamiento;
            //});
        }
        //else {
        if (this.solicitudEquipamientos.TSolicitudEquipamientoCollection != null && this.solicitudEquipamientos.TSolicitudEquipamientoCollection.length > 0) {
            this.inspeccion.TSolicitudEquipamientoCollection = this.solicitudEquipamientos.TSolicitudEquipamientoCollection;

            this.matriculasInsp = this.solicitudEquipamientos.TSolicitudEquipamientoCollection;

            this.matriculasInsp.map((o, i) => {
                const control = new UntypedFormControl(o.Inspeccion); // if first item set to true, else false
                (this.form.controls.matriculasInsp as UntypedFormArray).push(control);
            });
        }
        //}

        this.visibilityBtnRechazoParcial =
            this.inspeccion.IdDecision == EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE &&
            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.VER_RECHAZO_PARCIAL, this.IdEstadoSolicitud).Editable;
        //Cargo las tablas de los 'Rechazos'
        //this.inspeccion.TwInspeccionRechazo = this.solicitudEquipamientos.TwInspeccionRechazo;
        this.inspeccion.TSolicitudMedidaRechazoCollection = [];
        this.inspeccion.TSolicitudMotivoRechazoCollection = [];
    }

    checkEdit(rowData: TComentarioInspectorViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO).Editable && rowData.IdInspector == this.loggedInUser!.Id;
    }
    checkDelete(rowData: TComentarioInspectorViewModel): boolean {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_SEGUIMIENTO).Editable && rowData.IdInspector == this.loggedInUser!.Id;
    }

    onAdd() {
        this.router.navigate(['/importacion/solicitud/seguimientos', this.IdSolicitud, 'create', 'inspecciones']);
    }

    onEdit(item: TComentarioInspectorViewModel) {
        this.router.navigate(['/importacion/solicitud/seguimientos', item.IdSolicitud, 'detalleseguimiento', item.Id]);
    }

    onDelete(item: TComentarioInspectorViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.seguimientoService.deleteSeguimiento(item.Id).subscribe(res => {
                    this.addSuccessMessage('Seguimiento eliminado correctamente');
                    //this.onSearchButton();
                    this.ngOnInit();
                });
            },
        });
    }

    private CargarFR() {
        this.inspeccionesService.getFr(this.IdSolicitud).subscribe(result => {
            //FR
            this.mostrarFrecuenciaReducida = result != null && result.length > 0 && this.esInspector; //El solicitante ahora no lo ve (RDLF: 21/12/2020)

            if (this.mostrarFrecuenciaReducida) {
                this.frInsp = result;
            }
        });
    }

    private CargarFRSanidadExt() {
        if (!this.esInspector || !this.solicitudPuntoInspecccionHabilitadoSanidadExterior) {
            return;
        }
        this.inspeccionesService.getFrSanidadExt(this.IdSolicitud).subscribe(result => {
            // FR Higiene
            this.frSanidadExtInsp = result;
            this.mostrarFrSanidadExt = result != null && result.length > 0 && this.esInspector;
        });
    }

    private DisableControlsConsulta() {
        //this.form.controls['InspectorDocumental'].disable();
        this.form.controls['matriculasInsp'].disable();
        this.form.controls['Documental'].disable();
        this.form.controls['SeEfectuaIdentidadFisica'].disable();
        this.form.controls['Identidad'].disable();
        this.form.controls['Fisica'].disable();
        this.form.controls['Observaciones'].disable();
        this.form.controls['IdDecision'].disable();

        //Tipo inspección rechazo
        this.form.controls['TipoInspSupervisionPuestoInsp'].disable();
        this.form.controls['TipoInspControlSeguimientoNoSintomas'].disable();
        this.form.controls['TipoInspControlSeguimientoSiSintomas'].disable();

        //Motivos rechazo
        this.form.controls['IdMotivoRechazo'].disable();
        this.form.controls['IdDetalleMotivoRechazo'].disable();
        this.form.controls['IdElementoRechazo'].disable();
        this.form.controls['IdProductoMotivoRechazo'].disable();
        this.form.controls['IdEmbalajeMotivoRechazo'].disable();
        this.form.controls['ObservacionesMotivosRechazo'].disable();
        this.form.controls['OrganismoNocivo'].disable();
        this.form.controls['IdGradoContaminacion'].disable();
        this.form.controls['IdOrganismoNocivoNoReguladoUE'].disable();
        this.form.controls['IdOrganismoNocivoNoEspecie'].disable();

        //Medidas rechazo
        this.form.controls['FechaMedidasRechazo'].disable();
        this.form.controls['ObservacionesMedidasRechazo'].disable();
        this.form.controls['IdMedidaRechazo'].disable();
        this.form.controls['IdAlcanceRechazo'].disable();
        this.form.controls['IdProductoMedidaRechazo'].disable();
        this.form.controls['IdEmbalajeMedidaRechazo'].disable();
        this.form.controls['FechaComienzoCuarentena'].disable();
        this.form.controls['FechaTerminacionPrevistaCuarentena'].disable();
        this.form.controls['FechaTerminacionCuarentena'].disable();
        this.form.controls['IdPaisCuarentena'].disable();
        this.form.controls['LugarCuarentena'].disable();

        this.visibilidadEnGridDocumentos();
    }

    private loadSolicitudById(id: number) {
        //Fuerzo que lo haga siempre pq fallaba al refrescar cuando cambiaba de estado
        if (id) {
            // && !this.navMenuService.currentSolicitudImportacion.Id) {
            this.solicitud$ = this.solicitudService.getSolicitud(id).subscribe(result => {
                this.solicitud$.unsubscribe();
                this.solicitud = result;
                this.solicitudCargada$?.next(true);
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    private createForm() {
        this.form = this.fb.group({
            InspectorDocumental: '',
            InspectorIdentidad: '',
            InspectorFisica: '',
            FechaDocumental: null,
            FechaIdentidad: null,
            FechaFisica: null,
            Documental: null,
            SeEfectuaIdentidadFisica: false,
            Identidad: null,
            Fisica: null,
            Observaciones: '',
            IdDecision: null,
            matriculasInsp: new UntypedFormArray([]),
            validIdentidadFisicaRequerida: '',
            validPosicionamiento: '',
            validTipoInspeccionRechazo: '',
            validMedidas: '',
            validMotivos: '',
            Descripcion: '',
            IdPaisDescripcion: '',
            IdentificadorTraces: '',
            Localidad: '',
            Direccion: '',

            //Tipo inspección rechazo
            TipoInspSupervisionPuestoInsp: null,
            TipoInspControlSeguimientoNoSintomas: null,
            TipoInspControlSeguimientoSiSintomas: null,

            //Motivos rechazo
            IdMotivoRechazo: null,
            IdDetalleMotivoRechazo: null,
            IdElementoRechazo: null,
            IdProductoMotivoRechazo: null,
            IdEmbalajeMotivoRechazo: null,
            ObservacionesMotivosRechazo: '',
            OrganismoNocivo: '',
            IdGradoContaminacion: null,
            IdOrganismoNocivoNoReguladoUE: null,
            IdOrganismoNocivoNoEspecie: null,

            //Medidas rechazo
            FechaMedidasRechazo: '',
            ObservacionesMedidasRechazo: '',
            IdMedidaRechazo: null,
            IdAlcanceRechazo: null,
            IdProductoMedidaRechazo: null,
            IdEmbalajeMedidaRechazo: null,
            FechaComienzoCuarentena: null,
            FechaTerminacionPrevistaCuarentena: null, //[null, Validators.compose([dateValidators.greaterThan(FechaComienzoCuarentena)])],
            FechaTerminacionCuarentena: null, //[null, Validators.compose([dateValidators.greaterThan(FechaTerminacionPrevistaCuarentena)])],
            IdPaisCuarentena: null,
            LugarCuarentena: null, //['', Validators.compose([Validators.required, NoWhiteSpaceValidator.cannotContainSpace])],
        });
    }

    private updateForm() {
        //se usa el patchValue pq las matriculas se leen fuera de este bloque
        const letterDecision = this.decisionIdToLetter(this.inspeccion.IdDecision);

        this.form.patchValue({
            InspectorDocumental: this.inspeccion.IdUsuarioDocumentalDescripcion,
            InspectorIdentidad: this.inspeccion.IdUsuarioIdentidadDescripcion,
            InspectorFisica: this.inspeccion.IdUsuarioFisicaDescripcion,
            FechaDocumental: this.datepipe.transform(this.inspeccion.FechaDocumental, 'dd/MM/yyyy'),
            FechaIdentidad: this.datepipe.transform(this.inspeccion.FechaIdentidad, 'dd/MM/yyyy'),
            FechaFisica: this.datepipe.transform(this.inspeccion.FechaFisica, 'dd/MM/yyyy'),
            Documental: this.inspeccion.Documental,
            SeEfectuaIdentidadFisica: this.inspeccion.SeEfectuaIdentidadFisica,
            Identidad: this.inspeccion.Identidad,
            Fisica: this.inspeccion.Fisica,
            Observaciones: this.inspeccion.Observaciones,
            IdDecision: letterDecision,
            validIdentidadFisicaRequerida: '',
            validPosicionamiento: '',
            validTipoInspeccionRechazo: '',
            validMedidas: '',
            validMotivos: '',
            Descripcion:
                this.inspeccion.TwInspeccionRechazo != null && this.inspeccion.TwInspeccionRechazo.TwDestinoControl != null
                    ? this.inspeccion.TwInspeccionRechazo.TwDestinoControl.Descripcion
                    : null,
            IdPaisDescripcion:
                this.inspeccion.TwInspeccionRechazo != null && this.inspeccion.TwInspeccionRechazo.TwDestinoControl != null
                    ? this.inspeccion.TwInspeccionRechazo.TwDestinoControl.IdPaisDescripcion
                    : null,
            IdentificadorTraces:
                this.inspeccion.TwInspeccionRechazo != null && this.inspeccion.TwInspeccionRechazo.TwDestinoControl != null
                    ? this.inspeccion.TwInspeccionRechazo.TwDestinoControl.IdentificadorTraces
                    : null,
            Localidad:
                this.inspeccion.TwInspeccionRechazo != null && this.inspeccion.TwInspeccionRechazo.TwDestinoControl != null
                    ? this.inspeccion.TwInspeccionRechazo.TwDestinoControl.Localidad
                    : null,
            Direccion:
                this.inspeccion.TwInspeccionRechazo != null && this.inspeccion.TwInspeccionRechazo.TwDestinoControl != null
                    ? this.inspeccion.TwInspeccionRechazo.TwDestinoControl.Direccion
                    : null,

            FechaMedidasRechazo:
                this.inspeccion.TwInspeccionRechazo != null && this.inspeccion.TwInspeccionRechazo.FechaRechazo != null
                    ? new Date(this.inspeccion.TwInspeccionRechazo.FechaRechazo)
                    : '',
            ObservacionesMedidasRechazo: this.inspeccion.TwInspeccionRechazo != null ? this.inspeccion.TwInspeccionRechazo.ObservacionesRechazo : '',

            //Tipo inspección rechazo
            TipoInspSupervisionPuestoInsp:
                this.inspeccion.TwInspeccionRechazo != null ? this.inspeccion.TwInspeccionRechazo.TipoInspSupervisionPuestoInsp : null,
            TipoInspControlSeguimientoNoSintomas:
                this.inspeccion.TwInspeccionRechazo != null ? this.inspeccion.TwInspeccionRechazo.TipoInspControlSeguimientoNoSintomas : null,
            TipoInspControlSeguimientoSiSintomas:
                this.inspeccion.TwInspeccionRechazo != null ? this.inspeccion.TwInspeccionRechazo.TipoInspControlSeguimientoSiSintomas : null,

            //Motivos rechazo
            IdMotivoRechazo: null,
            IdDetalleMotivoRechazo: null,
            IdElementoRechazo: null,
            IdProductoMotivoRechazo: null,
            IdEmbalajeMotivoRechazo: null,
            ObservacionesMotivosRechazo: '',
            OrganismoNocivo: '',
            IdGradoContaminacion: null,
            IdOrganismoNocivoNoReguladoUE: null,
            IdOrganismoNocivoNoEspecie: null,

            //Medidas rechazo
            IdMedidaRechazo: null,
            IdAlcanceRechazo: null,
            IdProductoMedidaRechazo: null,
            IdEmbalajeMedidaRechazo: null,
            FechaComienzoCuarentena: '',
            FechaTerminacionPrevistaCuarentena: '',
            FechaTerminacionCuarentena: '',
            IdPaisCuarentena: null,
            LugarCuarentena: '',
        });

        this.mostrarMensajePredua = this.inspeccion.SeEfectuaIdentidadFisica && this.EsPredua && !this.editMode;
        //Carga de los check labels
        this.labelDocumental = this.inspeccion.Documental ? this.labelApto : this.inspeccion.Documental == null ? '' : this.labelNoApto;
        this.labelIdentidad = this.inspeccion.Identidad ? this.labelApto : this.inspeccion.Identidad == null ? '' : this.labelNoApto;
        this.labelFisica = this.inspeccion.Fisica ? this.labelApto : this.inspeccion.Fisica == null ? '' : this.labelNoApto;

        this.Documental = this.inspeccion.Documental!;
        this.Identidad = this.inspeccion.Identidad!;
        this.Fisica = this.inspeccion.Fisica!;
        this.SeEfectuaIdentidadFisica = this.inspeccion.SeEfectuaIdentidadFisica;
        if (letterDecision == EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR_PARCIALMENTE) {
            this.visibilityMsgRechazoParcial = true;
        }
        if (letterDecision == EnumIdsTwTcDecisionInspeccionLetter.NO_PROCEDE) {
            this.visibilityMensajeNoProcede = true;
            this.labelNoProcede = 'No Procede *';
        }

        if (this.habilitarEdicion && this.Documental != null) {
            this.form.controls['SeEfectuaIdentidadFisica'].enable();
            this.SelectedIdentidadFisicaNoClick();
        }
    }

    onGuardarInspecciones(): void {
        if (this.form.value.IdDecision == EnumIdsTwTcDecisionInspeccionLetter.NO_PROCEDE) {
            this.confirmationService.confirm({
                message: '¿Está seguro?. Ha seleccionado que NO PROCEDE GUARDAR LA INSPECCIÓN.',
                accept: () => {
                    this.onSubmit();
                },
            });
        } else if (this.form.value.IdDecision == EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR_PARCIALMENTE) {
            this.confirmationService.confirm({
                message: '¿Está seguro de guardar la inspección de la solicitud?. Ha seleccionado RECHAZO PARCIAL.',
                accept: () => {
                    this.onSubmit();
                },
            });
        } else if (this.form.value.IdDecision == EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR_PARCIALMENTE) {
            this.confirmationService.confirm({
                message: '¿Está seguro de guardar la inspección de la solicitud?. Ha seleccionado ' + this.DESCRIPCION_NO_APTO_POR_HIGIENE + '.',
                accept: () => {
                    this.onSubmit();
                },
            });
        } else if (this.form.value.IdDecision == EnumIdsTwTcDecisionInspeccionLetter.NO_APTO_POR_HIGIENE) {
            this.confirmationService.confirm({
                message: '¿Está seguro de guardar la inspección de la solicitud?. Ha seleccionado ' + this.DESCRIPCION_NO_APTO_POR_HIGIENE + '.',
                accept: () => {
                    this.onSubmit();
                },
            });
        } else {
            this.confirmationService.confirm({
                message: '¿Está seguro de guardar la inspección de la solicitud?.',
                accept: () => {
                    this.habilitarEdicion = false; //para bloquear enseguida las casillas check de selección, si las hubiera
                    this.visibilidadEnGridDocumentos();
                    this.onSubmit();
                },
            });
        }
    }

    onRevisionSolicitanteConfirm(): void {
        let mensajeRevision: string;
        if (this.inspeccion.Observaciones == '') {
            mensajeRevision = 'Va a devolver la solicitud al solicitante sin Observaciones guardadas, ¿está seguro?';
        } else {
            mensajeRevision = 'Va a devolver la solicitud al solicitante, ¿está seguro?';
        }

        this.confirmationService.confirm({
            message: mensajeRevision,
            accept: () => {
                let params = new HttpParams();

                params = params.append('idSolicitud', this.IdSolicitud.toString());
                params = params.append('idUsuario', this.loggedInUser!.Id.toString());

                this.inspeccionesService.revisionSolicitante(params).subscribe({
                    next: () => {
                        this.addSuccessMessage('Solicitud devuelta correctamente');

                        this.ngOnInit();
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    onPresentarRechazoParcial(): void {
        //En este momento hay que guardar antes de navegar a la pantalla detalle, para conservar los cambios (Inspecciones, Observaciones, Decision, etc.)
        this.router.navigate(['/importacion/solicitud/inspecciones/', this.IdSolicitud, 'rechazoparcial']);
    }

    onSelectedDecision() {
        if (this.form.controls['IdDecision'].value == EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR_PARCIALMENTE) {
            this.visibilityMsgRechazoParcial = true;
            this.visibilityMensajeNoProcede = false;
            this.labelNoProcede = 'No Procede';
            //this.visibilityBtnRechazoParcial =
            //    this.editMode && this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.VER_RECHAZO_PARCIAL, this.IdEstadoSolicitud).Editable;
        } else {
            this.visibilityMsgRechazoParcial = false;
            this.visibilityMensajeNoProcede = false;
            this.labelNoProcede = 'No Procede';
            if (this.form.controls['IdDecision'].value == EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR) {
                this.addValidator('Observaciones', Validators.required);
                this.requerirObservaciones = true;
            } else {
                this.removeValidators('Observaciones');
                this.requerirObservaciones = false;
                if (this.form.controls['IdDecision'].value == EnumIdsTwTcDecisionInspeccionLetter.NO_PROCEDE) {
                    this.visibilityMensajeNoProcede = true;
                    this.labelNoProcede = 'No Procede *';
                }
            }
        }
        this.gestionarRechazo();
    }

    onSelectedIdentidadFisica() {
        this.SeEfectuaIdentidadFisica = this.form.controls['SeEfectuaIdentidadFisica'].value;

        if (!(this.habilitarEdicion && this.EsPredua)) {
            if (this.SeEfectuaIdentidadFisica) {
                this.form.controls['Identidad'].enable();
                this.form.controls['Fisica'].enable();
                //this.requerirIdentidad = true;
                //this.requerirFisica = true;
            } else {
                this.form.patchValue({
                    Identidad: null,
                    Fisica: null,
                });
                this.Identidad = null;
                this.Fisica = null;

                this.form.controls['Identidad'].disable();
                this.form.controls['Fisica'].disable();
                this.labelIdentidad = '';
                this.labelFisica = '';
                this.requerirObservaciones = false;
                //this.requerirIdentidad = false;
                //this.requerirFisica = false;
            }
        }
        //SI ES PREDUA Y ESTA HABILITADA PARA EDITAR
        else {
            if (this.SeEfectuaIdentidadFisica) {
                //SI HE GRABADO LA INSPECCION y SE EFECTUA IDENTIDAD Y FISICA
                if (this.editMode && this.inspeccion != null && this.inspeccion.SeEfectuaIdentidadFisica) {
                    this.form.controls['Identidad'].enable();
                    this.form.controls['Fisica'].enable();
                    this.form.controls['IdDecision'].enable();
                }
                //SI NO HE GRABADO LA INSPECCION
                else {
                    this.form.controls['IdDecision'].disable();
                    this.form.controls['Identidad'].disable();
                    this.form.controls['Fisica'].disable();
                }

                this.mostrarMensajePredua = true;
            } else {
                this.mostrarMensajePredua = false;
                this.form.controls['IdDecision'].enable();

                this.form.patchValue({
                    Identidad: null,
                    Fisica: null,
                });
                this.Identidad = null;
                this.Fisica = null;
                this.labelIdentidad = '';
                this.labelFisica = '';

                this.form.controls['Identidad'].disable();
                this.form.controls['Fisica'].disable();
            }
        }

        this.resetDecision();
        this.gestionarVisibilidadDecision();

        //if (this.requerirFisica || this.requerirIdentidad) {
        //    this.addValidator('validIdentidadFisicaRequerida', Validators.required);
        //} else {
        //    this.removeValidators('validIdentidadFisicaRequerida');
        //}
    }

    // Método que se llama sin hacer click
    private SelectedIdentidadFisicaNoClick() {
        this.SeEfectuaIdentidadFisica = this.form.controls['SeEfectuaIdentidadFisica'].value;
        //this.SeEfectuaIdentidadFisica =
        //    this.form.value.SeEfectuaIdentidadFisica != undefined ? this.form.value.SeEfectuaIdentidadFisica : this.inspeccion.SeEfectuaIdentidadFisica;

        if (!(this.habilitarEdicion && this.EsPredua)) {
            if (this.form.value.SeEfectuaIdentidadFisica) {
                this.form.controls['Identidad'].enable();
                this.form.controls['Fisica'].enable();
                //Como está marcada "Se efectúa Inspección Identidad y/o Física", se obliga a marcar alguna de las dos
                //detectar si Identidad o Física están marcados (Apto/No apto)
                //this.requerirIdentidad = !(this.form.value.Identidad != null || this.form.value.Fisica != null);
                //this.requerirFisica = !(this.form.value.Identidad != null || this.form.value.Fisica != null);
            } else {
                this.form.patchValue({
                    Identidad: null,
                    Fisica: null,
                });
                this.Identidad = null;
                this.Fisica = null;

                this.form.controls['Identidad'].disable();
                this.form.controls['Fisica'].disable();
                this.labelIdentidad = '';
                this.labelFisica = '';

                //this.requerirIdentidad = false;
                //this.requerirFisica = false;
            }
        }
        //SI ES PREDUA Y ESTA HABILITADA PARA EDITAR
        else {
            if (this.SeEfectuaIdentidadFisica) {
                //SI HE GRABADO LA INSPECCION y SE EFECTUA IDENTIDAD Y FISICA
                if (this.editMode && this.inspeccion != null && this.inspeccion.SeEfectuaIdentidadFisica) {
                    this.form.controls['Identidad'].enable();
                    this.form.controls['Fisica'].enable();
                    this.form.controls['IdDecision'].enable();
                }
                //SI NO HE GRABADO LA INSPECCION
                else {
                    this.form.controls['IdDecision'].disable();
                    this.form.controls['Identidad'].disable();
                    this.form.controls['Fisica'].disable();
                }

                this.mostrarMensajePredua = true;
            } else {
                this.mostrarMensajePredua = false;
                this.form.controls['IdDecision'].enable();

                this.form.patchValue({
                    Identidad: null,
                    Fisica: null,
                });
                this.Identidad = null;
                this.Fisica = null;
                this.labelIdentidad = '';
                this.labelFisica = '';

                this.form.controls['Identidad'].disable();
                this.form.controls['Fisica'].disable();
            }
        }

        //if (this.requerirFisica || this.requerirIdentidad) {
        //    this.addValidator('validIdentidadFisicaRequerida', Validators.required);
        //} else {
        //    this.removeValidators('validIdentidadFisicaRequerida');
        //}
    }

    onChangeDocumental() {
        if (this.form.value.Documental == null) {
            this.labelDocumental = '';
            this.requerirObservaciones = false;
        } else if (this.form.value.Documental) {
            this.labelDocumental = this.labelApto;
            this.form.controls['SeEfectuaIdentidadFisica'].enable();
            this.requerirObservaciones = false;
        } else if (!this.form.value.Documental) {
            this.labelDocumental = this.labelNoApto;
            this.form.controls['SeEfectuaIdentidadFisica'].disable();
            this.requerirObservaciones = true;

            //this.requerirIdentidad = false;
            //this.requerirFisica = false;

            this.form.patchValue({
                SeEfectuaIdentidadFisica: false,
            });

            this.SelectedIdentidadFisicaNoClick();
        }

        this.Documental = this.form.value.Documental;

        this.resetDecision();
        this.gestionarVisibilidadDecision();

        //if (this.requerirFisica || this.requerirIdentidad) {
        //    this.addValidator('validIdentidadFisicaRequerida', Validators.required);
        //} else {
        //    this.removeValidators('validIdentidadFisicaRequerida');
        //}
    }

    onChangeIdentidad() {
        if (this.form.value.Identidad == null) {
            this.labelIdentidad = '';
            //this.requerirIdentidad = this.Fisica == null;
            //this.requerirFisica = this.Fisica == null;
        } else if (this.form.value.Identidad) {
            this.labelIdentidad = this.labelApto;
            //this.requerirIdentidad = false;
            //this.requerirFisica = false;
        } else if (!this.form.value.Identidad) {
            this.labelIdentidad = this.labelNoApto;
            //this.requerirIdentidad = false;
            //this.requerirFisica = false;
        }

        this.requerirObservaciones = this.labelIdentidad === this.labelNoApto || this.labelFisica === this.labelNoApto;

        this.Identidad = this.form.value.Identidad;

        this.resetDecision();
        this.gestionarVisibilidadDecision();

        //if (this.requerirFisica || this.requerirIdentidad) {
        //    this.addValidator('validIdentidadFisicaRequerida', Validators.required);
        //} else {
        //    this.removeValidators('validIdentidadFisicaRequerida');
        //}
    }

    onChangeFisica() {
        if (this.form.value.Fisica == null) {
            this.labelFisica = '';
            //this.requerirIdentidad = this.Identidad == null;
            //this.requerirFisica = this.Identidad == null;
        } else if (this.form.value.Fisica) {
            this.labelFisica = this.labelApto;
            //this.requerirFisica = false;
            //this.requerirIdentidad = false;
        } else if (!this.form.value.Fisica) {
            this.labelFisica = this.labelNoApto;
            //this.requerirFisica = false;
            //this.requerirIdentidad = false;
        }

        this.requerirObservaciones = this.labelIdentidad === this.labelNoApto || this.labelFisica === this.labelNoApto;

        this.Fisica = this.form.value.Fisica;

        this.resetDecision();
        this.gestionarVisibilidadDecision();

        //if (this.requerirFisica || this.requerirIdentidad) {
        //    this.addValidator('validIdentidadFisicaRequerida', Validators.required);
        //} else {
        //    this.removeValidators('validIdentidadFisicaRequerida');
        //}
    }

    getMatriculaControls() {
        return (<UntypedFormArray>this.form.controls.matriculasInsp).controls;
    }

    getFrControls() {
        return (<UntypedFormArray>this.form.controls.frInsp).controls;
    }

    private gestionarVisibilidadDecision() {
        this.habilitarAceptarDecision = false;

        if (this.Documental) {
            //Si es Re-Importación (la Inspección Identidad es obligatoria)
            if (this.EsReImportacion) {
                if ((this.Identidad && this.Fisica == null) || (this.Identidad && this.Fisica)) {
                    this.habilitarAceptarDecision = true;
                }
            }
            //Si es Normal (NO Re-Impotación)
            else {
                if (
                    !this.SeEfectuaIdentidadFisica ||
                    (this.Identidad && this.Fisica == null) ||
                    (this.Fisica && this.Identidad == null) ||
                    (this.Identidad && this.Fisica)
                ) {
                    this.habilitarAceptarDecision = true;
                }
            }
        }

        //para Rechazar, mínimo tiene que haber una inspección en "No Apto"
        this.habilitarRechazarDecision = this.Documental == false || this.Identidad == false || this.Fisica == false;
        this.visibilityNoProcede = this.EsPredua && this.numeroProductos == 1 && this.Documental != null;
        //al menos tiene que estar visible alguna de las posibles decisiones, si no, ocultamos el panel de decisión hasta que se cumpla alguna condición
        this.visibilityDecision = this.habilitarAceptarDecision || this.habilitarRechazarDecision || this.canRechazoParcial || this.visibilityNoProcede;

        // El botón "No apto por higiene", se controla con el getter canNoAptoPorHigiene
    }

    private resetDecision() {
        this.form.patchValue({
            IdDecision: null,
        });
        this.visibilityMedidasRechazos = false;
        this.visibilityMsgRechazoParcial = false;
        this.visibilityMensajeNoProcede = false;
        this.labelNoProcede = 'No Procede';
    }

    private gestionarRechazo() {
        if (this.form.value.IdDecision == EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR) {
            this.visibilityMedidasRechazos = true;

            this.SetColumnasGridDocumentos();

            //para modo consulta no hace falta cargar los combos
            if (this.habilitarEdicion) {
                this.loadRechazo();
            }

            //Cargar documentos de la solicitud por si quiere adjuntar alguna al rechazo. Por aquí entra sólo si la inspección es nueva ya que no se traen los documentos desde servidor
            if (this.numeroDocumentos == 0) {
                this.cargarDocumentos();
            }
        } else {
            this.visibilityMedidasRechazos = false;
        }
    }

    private SetColumnasGridDocumentos() {
        this.colsDocumentos = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            {
                field: 'ReferenciaTraces',
                header: 'Referencia Traces',
                display: 'none',
            },
            { field: 'IdTipoDocumentacionDescripcion', header: 'Tipo' },
            { field: 'Texto', header: 'Número' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdPaisDescripcion', header: 'País' },
            { field: 'Perfil', header: 'Perfil' },
        ];

        //this.documentosAttachedRechazoBDChecked = [];
    }

    private loadRechazo() {
        this.globalService.getMedidasRechazo().subscribe(result => {
            this.listMedidasRechazo = result;
        });

        this.globalService.getMotivosRechazo().subscribe(result => {
            this.listMotivosRechazo = result;
        });

        //Detalles de No Cumplimiento:
        //Los productos se cargan al inicio tanto si hay inspección (getinspeccion --> this.inspeccion) como si no la hay (getEquipamientos --> this.solicitudEquipamientos)
        //editMode distingue si cargamos una inspección nueva o existente y desde qué objeto, por tanto, hay que cargar los productos y embalajes de la solicitud para alimentar los combos en los rechazos
        if (this.editMode) {
            //cargar combo productos con esta colección
            this.listProductosSolicitud = this.inspeccion.TProductoSolicitudCollection;
            this.listEmbalajesSolicitud = this.inspeccion.TwEmbalajesCollection;

            this;
        } else {
            //cargar combo productos con esta colección
            this.listProductosSolicitud = this.solicitudEquipamientos.TProductoSolicitudCollection;
            this.listEmbalajesSolicitud = this.solicitudEquipamientos.TwEmbalajesCollection;
        }
    }

    private cargarDocumentos(): void {
        this.documentosService.getSolicitudDocumentos(this.IdSolicitud).subscribe(result => {
            this.solicitudDocumento = result;

            this.numeroDocumentos = this.solicitudDocumento.TDocumentoSolicitudCollection!.length;
            this.documentos = this.solicitudDocumento.TDocumentoSolicitudCollection;

            //Grid Documentos se visualizará si:
            //1. Inspección nueva. Si la decisión es Rechazar entonces puede adjuntar docs
            //2. Inspección editada y se adjuntó algún doc al rechazo. Se visualizan qué docs se adjuntaron
            if (this.inspeccion.IdEstadoChedPp == undefined || this.inspeccion.IdEstadoChedPp == EnumIdsEstadoChedPP.ID_PENDIENTE) {
                this.visibilityDocumentos = true;
                this.tituloDocumentosAdjuntos = this.strTituloMarcarDocumentosAdjuntos;
            } else {
                this.visibilityDocumentos = this.documentos.filter(x => x.AttachedRechazo)!.length > 0 ? true : false;
                this.documentos = this.documentos.filter(x => x.AttachedRechazo);
                this.documentosAttachedRechazoBDChecked = this.documentos; //cargar el array de documentos seleccionados para pintarlo en pantalla
                this.tituloDocumentosAdjuntos = this.visibilityDocumentos ? this.strTituloMarcadosDocumentosAdjuntos : this.strTituloMarcarDocumentosAdjuntos;
            }
        });
    }

    //Si no hay documentos marcados, ocultar el grid de documentos.
    //Puede haber documentos marcados en:
    //1. Inspección existente: AttachedRechazo de cada documento guardado y que fue seleccionado viene a 1 desde BD.
    //2. Inspección nueva:  la selección de un documento por el usuario en pantalla no produce el cambio de valor en AttachedRechazo en ese momento sino que ese cambio se hace en servidor si el
    //envío a Traces va bien. Así que también hay que preguntar por el array de documentos seleccionados en pantalla que se llama documentosAttachedRechazoUserCheck para saber si visualizar o no
    //el grid de documentos deshabilitado, etc.
    private visibilidadEnGridDocumentos() {
        //check selección tabla documentos
        this.visibilityTableHeaderCheckbox = true;
        this.visibilityDocumentos = false;

        if (this.documentos != undefined) {
            //estamos cargando un rechazo así que ya no es editable, quitar casilla selección documentos
            if (this.documentos.findIndex(x => x.AttachedRechazo) > -1 || this.documentosAttachedRechazoUserCheck.length > 0) {
                this.visibilityDocumentos = true;
                this.documentos = this.documentos.filter(item => this.documentosAttachedRechazoUserCheck.includes(item.Id));
                this.visibilityTableHeaderCheckbox = false;
            }

            this.tituloDocumentosAdjuntos = this.visibilityDocumentos ? this.strTituloMarcadosDocumentosAdjuntos : this.strTituloMarcarDocumentosAdjuntos;
        }
    }

    onDownload(item: TDocumentoSolicitudViewModel) {
        this.uploadedFile = new UploadedFileViewModel();

        this.uploadedFile.Guid = item.CodigoStorage;
        this.uploadedFile.Name = item.NombreArchivo;

        this.uploaderService.download(this.uploadedFile).subscribe(res => {
            this.OpenDownloadedFile(res);
        });
    }

    isTracesInfoVisible(item: TDocumentoSolicitudViewModel) {
        //Columna ReferenciaTraces de tabla TDocumentoSolicitud:
        // 0       --> fichero NO CF no sube a Traces
        // xxxxxxx --> fichero SÍ CF sí sube a Traces
        // NULL    --> fichero SÍ CF sí sube a Traces (falló subida)
        // 9999999 --> fichero SÍ CF no sube a Traces (porque baja de Traces)

        if (item.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_CANARIAS) {
            return false;
        }

        return item.ReferenciaTraces == '0' ? false : true;
    }

    onRowSelect(event: any): void {
        this.documentosAttachedRechazoUserCheck.push(event.data.Id);
    }

    onRowUnselect(event: any): void {
        this.documentosAttachedRechazoUserCheck.splice(this.documentosAttachedRechazoUserCheck.indexOf(event.data.Id), 1);
    }

    selectAllRows(event: any): void {
        if (event.checked) {
            this.documentosAttachedRechazoUserCheck = [];
            this.documentos.forEach(x => this.documentosAttachedRechazoUserCheck.push(x.Id));
        } else {
            this.documentosAttachedRechazoUserCheck = [];
        }
    }

    /*   I N I C I O   M O T I V O S   R E C H A Z O   */

    onSelectMotivoRechazo() {
        this.form.patchValue({
            IdDetalleMotivoRechazo: null,
            OrganismoNocivo: '',
            IdGradoContaminacion: null,
            IdOrganismoNocivoNoReguladoUE: null,
            IdOrganismoNocivoNoEspecie: null,
        });

        this.listDetallesMotivoRechazo = [];
        //no limpiar listElementosRechazo porque no es dependiente de nadie, siempre tiene Productos, Embalajes, Productos y Embalajes

        this.idOrganismoNocivo = null;

        this.esOrganismoNocivo_No_ReguladoUE = false;
        this.esOrganismoNocivo_No_Especie = false;

        this.visualizarCamposDeOrganismosNocivos = false;

        if (this.form.value.IdMotivoRechazo !== null) {
            //se trae también la columna CodigoTraces de TwTcDetalleMotivoRechazo
            this.globalService.getDetalleMotivosRechazoById(this.form.value.IdMotivoRechazo).subscribe(result => {
                this.listDetallesMotivoRechazo = result;
            });
        }
    }

    onSelectDetalleMotivoRechazo() {
        this.form.patchValue({
            OrganismoNocivo: '',
            IdGradoContaminacion: null,
            IdOrganismoNocivoNoReguladoUE: null,
            IdOrganismoNocivoNoEspecie: null,
        });

        //no limpiar listElementosRechazo porque no es dependiente de nadie, siempre tiene Productos, Embalajes, Productos y Embalajes

        this.idOrganismoNocivo = null;

        this.esOrganismoNocivo_No_ReguladoUE = false;
        this.esOrganismoNocivo_No_Especie = false;

        this.visualizarCamposDeOrganismosNocivos = false;

        const _idDetalleMotivoRechazo = this.form.value.IdDetalleMotivoRechazo;

        //Detectar si ha elegido Organismos Nocivos de TwTcDetalleMotivoRechazo para mostrar otros combos. 1º se busca en la lista de datos el elemento seleccionado y se mira su columna CodigoTraces
        const seleccionado = this.listDetallesMotivoRechazo.find(x => x.Id == _idDetalleMotivoRechazo);

        if (seleccionado != null && this.arrayCodigosTracesParaDetalleMotivoOrganismoNocivo.includes((<MotivoMedidaViewModel>seleccionado).CodigoTraces)) {
            this.visualizarCamposDeOrganismosNocivos = true;

            this.cargarComboGradoContaminacion();
        } else {
            this.visualizarCamposDeOrganismosNocivos = false;
        }
    }

    //Producto motivo
    onSelectProductoMotivoRechazo(event: TProductoSolicitudViewModel[]) {
        this.listProductosMotivoRechazoSeleccionados = [];
        event.forEach(val => this.listProductosMotivoRechazoSeleccionados.push(val));

        this.requerirProductoMotivo =
            this.listEmbalajesMotivoRechazoSeleccionados.length == 0
                ? true
                : this.listProductosMotivoRechazoSeleccionados.length > 0
                  ? this.requerirProductoMotivo
                  : false;
        this.requerirEmbalajeMotivo = !this.requerirProductoMotivo;
    }

    //Embalaje motivo
    onSelectEmbalajeMotivoRechazo(event: TwEmbalajesViewModel[]) {
        this.listEmbalajesMotivoRechazoSeleccionados = [];
        event.forEach(val => this.listEmbalajesMotivoRechazoSeleccionados.push(val));

        this.requerirEmbalajeMotivo =
            this.listProductosMotivoRechazoSeleccionados.length == 0
                ? true
                : this.listEmbalajesMotivoRechazoSeleccionados.length > 0
                  ? this.requerirEmbalajeMotivo
                  : false;
        this.requerirProductoMotivo = !this.requerirEmbalajeMotivo;
    }

    //añadir motivo
    onAddMotivoRechazo() {
        //verificar que están informados los campos obligatorios, inicializamos a false
        this.form.patchValue({
            validMotivos: '',
        });

        if (this.form.value.IdMotivoRechazo != null && this.form.value.IdDetalleMotivoRechazo != null && this.form.value.IdElementoRechazo != null) {
            const currentSolicitudMotivo = new TwSolicitudMotivoRechazoViewModel();
            currentSolicitudMotivo.IdSolicitud = this.inspeccion.IdSolicitud;
            currentSolicitudMotivo.IdMotivoRechazo = this.form.value.IdMotivoRechazo;
            currentSolicitudMotivo.IdDetalleMotivoRechazo = this.form.value.IdDetalleMotivoRechazo;
            currentSolicitudMotivo.IdElementoRechazo = this.form.value.IdElementoRechazo;
            currentSolicitudMotivo.ObservacionesMotivosRechazo = this.form.value.ObservacionesMotivosRechazo;

            ////Comprobamos que el motivo no esté ya incluido
            //let yaIncluido =
            //    this.inspeccion.TSolicitudMotivoRechazoCollection != null &&
            //    this.inspeccion.TSolicitudMotivoRechazoCollection.find(
            //        it =>
            //            it.IdMotivoRechazo == currentSolicitudMotivo.IdMotivoRechazo &&
            //            it.IdDetalleMotivoRechazo == currentSolicitudMotivo.IdDetalleMotivoRechazo &&
            //            it.IdElementoRechazo == currentSolicitudMotivo.IdElementoRechazo,
            //    );

            //if (yaIncluido) {
            //    this.addErrorMessage('El Motivo ya existe. Revise los Motivos añadidos');
            //    return;
            //}

            //para poder acceder a la descripción del id seleccionado de cada combo y pintarlo en el grid de motivos añadidos
            const motivoSeleccionado = this.listMotivosRechazo.find(it => it.Id == this.form.value.IdMotivoRechazo);
            const detalleMotivoSeleccionado = this.listDetallesMotivoRechazo.find(it => it.Id == this.form.value.IdDetalleMotivoRechazo);
            const elementoSeleccionado = this.listElementosRechazo.find(it => it.Id == this.form.value.IdElementoRechazo);

            currentSolicitudMotivo.IdMotivoRechazoDescripcion = motivoSeleccionado!.Descripcion;
            currentSolicitudMotivo.IdDetalleMotivoRechazoDescripcion = detalleMotivoSeleccionado!.Descripcion;
            currentSolicitudMotivo.IdElementoRechazoDescripcion = elementoSeleccionado!.Descripcion;

            //Organismo Nocivo
            currentSolicitudMotivo.IdOrganismoNocivo = this.idOrganismoNocivo;
            currentSolicitudMotivo.IdOrganismoNocivoDescripcion = this.form.value.OrganismoNocivo; //eppo + nombre científico

            //Grado Contaminación
            if (this.form.value.IdGradoContaminacion != null) {
                const gradoContaminacionSeleccionado = this.listGradoContaminacion.find(it => it.Id == this.form.value.IdGradoContaminacion);
                currentSolicitudMotivo.IdGradoContaminacion = this.form.value.IdGradoContaminacion;
                currentSolicitudMotivo.IdGradoContaminacionDescripcion = gradoContaminacionSeleccionado!.Descripcion;
            }

            //Organismo Nocivo No Regulado UE
            if (this.form.value.IdOrganismoNocivoNoReguladoUE != null) {
                const organismoNocivoNoReguladoUESeleccionado = this.listOrganismoNocivoNoReguladoUE.find(
                    it => it.Id == this.form.value.IdOrganismoNocivoNoReguladoUE,
                );
                currentSolicitudMotivo.IdOrganismoNocivoNoReguladoUE = this.form.value.IdOrganismoNocivoNoReguladoUE;
                currentSolicitudMotivo.IdOrganismoNocivoNoReguladoUEDescripcion = organismoNocivoNoReguladoUESeleccionado!.Descripcion;
            }

            //Organismo Nocivo No Especie
            if (this.form.value.IdOrganismoNocivoNoEspecie != null) {
                const organismoNocivoNoEspecieSeleccionado = this.listOrganismoNocivoNoEspecie.find(it => it.Id == this.form.value.IdOrganismoNocivoNoEspecie);
                currentSolicitudMotivo.IdOrganismoNocivoNoEspecie = this.form.value.IdOrganismoNocivoNoEspecie;
                currentSolicitudMotivo.IdOrganismoNocivoNoEspecieDescripcion = organismoNocivoNoEspecieSeleccionado!.Descripcion;
            }

            //Gestionar si se indicaron  P R O D U C T O S  en los  M O T I V O S  del rechazo
            if (this.listProductosMotivoRechazoSeleccionados.length > 0) {
                this.listProductosMotivoRechazoSeleccionados.forEach(item => {
                    //objeto para visualizar en el grid los productos añadidos a los motivos
                    if (currentSolicitudMotivo.IdProductoMotivoRechazoDescripcion == '') {
                        currentSolicitudMotivo.IdProductoMotivoRechazoDescripcion = item.IdTaricProductoNombreComun;
                    } else {
                        currentSolicitudMotivo.IdProductoMotivoRechazoDescripcion =
                            currentSolicitudMotivo.IdProductoMotivoRechazoDescripcion + ', ' + item.IdTaricProductoNombreComun;
                    }

                    //objeto para el servidor con los productos añadidos a los motivos
                    const productoRechazoMotivo = new TwProductoRechazoMotivo();
                    productoRechazoMotivo.IdProductoMotivoRechazo = item.Id;
                    productoRechazoMotivo.IdProductoMotivoRechazoDescripcion = item.IdTaricProductoNombreComun;
                    productoRechazoMotivo.IdSolicitudMotivoRechazo = currentSolicitudMotivo.Id; //por asignar en servidor al guardar

                    currentSolicitudMotivo.ProductoMotivoRechazoCollection.push(productoRechazoMotivo);
                });
                this.form.patchValue({
                    validMotivos: true,
                });
            }

            //Gestionar si se indicaron  E M B A L A J E S  en los  M O T I V O S  del rechazo
            if (this.listEmbalajesMotivoRechazoSeleccionados.length > 0) {
                this.listEmbalajesMotivoRechazoSeleccionados.forEach(item => {
                    //objeto para visualizar en el grid los embalajes añadidos a los motivos
                    if (currentSolicitudMotivo.IdEmbalajeMotivoRechazoDescripcion == '') {
                        currentSolicitudMotivo.IdEmbalajeMotivoRechazoDescripcion = item.IdTaricEmbalajeDescripcion;
                    } else {
                        currentSolicitudMotivo.IdEmbalajeMotivoRechazoDescripcion =
                            currentSolicitudMotivo.IdEmbalajeMotivoRechazoDescripcion + ', ' + item.IdTaricEmbalajeDescripcion;
                    }

                    //objeto para el servidor con los embalajes añadidos a los motivos
                    const embalajeRechazoMotivo = new TwEmbalajeRechazoMotivo();
                    embalajeRechazoMotivo.IdEmbalajeMotivoRechazo = item.Id;
                    embalajeRechazoMotivo.IdEmbalajeMotivoRechazoDescripcion = item.IdTaricEmbalajeDescripcion;
                    embalajeRechazoMotivo.IdSolicitudMotivoRechazo = currentSolicitudMotivo.Id; //por asignar en servidor al guardar

                    currentSolicitudMotivo.EmbalajeMotivoRechazoCollection.push(embalajeRechazoMotivo);
                });
                this.form.patchValue({
                    validMotivos: true,
                });
            }

            //RDLF-->cambia la forma de introducir elementos al array para que refresque la p-tabla
            //this.inspeccion.TSolicitudMotivoRechazoCollection = [...this.inspeccion.TSolicitudMotivoRechazoCollection, currentSolicitudMotivo];

            if (this.form.value.validMotivos) {
                //verificar que están informados estos campos cuando son obligatorios
                this.form.patchValue({
                    validMotivos: this.visualizarCamposDeOrganismosNocivos
                        ? this.form.value.OrganismoNocivo != '' &&
                          this.form.value.IdGradoContaminacion > 0 &&
                          (this.esOrganismoNocivo_No_ReguladoUE ? this.form.value.IdOrganismoNocivoNoReguladoUE > 0 : true) &&
                          (this.esOrganismoNocivo_No_Especie ? this.form.value.IdOrganismoNocivoNoEspecie > 0 : true)
                        : true,
                });

                if (this.form.value.validMotivos) {
                    this.inspeccion.TSolicitudMotivoRechazoCollection = [...this.inspeccion.TSolicitudMotivoRechazoCollection, currentSolicitudMotivo];
                    this.removeValidators('validMotivos');
                } else {
                    this.addErrorMessage('Revise los datos del Motivo');
                    return;
                }
            } else {
                this.addErrorMessage('Revise los datos del Motivo');
                return;
            }

            this.form.patchValue({
                IdMotivoRechazo: null,
                IdDetalleMotivoRechazo: null,
                IdElementoRechazo: null,
                IdProductoMotivoRechazo: null,
                IdEmbalajeMotivoRechazo: null,
                ObservacionesMotivosRechazo: '',
                OrganismoNocivo: '',
                IdGradoContaminacion: null,
                IdOrganismoNocivoNoReguladoUE: null,
                IdOrganismoNocivoNoEspecie: null,
            });

            //una vez ya tratadas estas listas se limpian para que no afecten al añadir el siguiente motivo
            this.listProductosMotivoRechazoSeleccionados = [];
            this.listEmbalajesMotivoRechazoSeleccionados = [];
            this.idOrganismoNocivo = null;

            this.requerirProductoMotivo = true;
            this.requerirEmbalajeMotivo = false;
        }
    }

    //eliminar motivo
    onDeleteMotivoRechazo(motivo: TwSolicitudMotivoRechazoViewModel) {
        //this.inspeccion.TSolicitudMotivoRechazoCollection.splice(this.inspeccion.TSolicitudMotivoRechazoCollection.indexOf(motivo), 1);
        //RDLF-->cambia la forma de eliminar elementos al array para que refresque la p-tabla
        this.inspeccion.TSolicitudMotivoRechazoCollection = [
            ...this.inspeccion.TSolicitudMotivoRechazoCollection.slice(0, this.inspeccion.TSolicitudMotivoRechazoCollection.indexOf(motivo)),
            ...this.inspeccion.TSolicitudMotivoRechazoCollection.slice(this.inspeccion.TSolicitudMotivoRechazoCollection.indexOf(motivo) + 1),
        ];
    }

    /*   F I N   M O T I V O S   */

    /*   I N I C I O   M E D I D A S   */

    onSelectMedidaRechazo() {
        this.form.patchValue({
            IdAlcanceRechazo: null,
        });

        this.listAlcancesRechazo = [];

        if (this.form.value.IdMedidaRechazo != null) {
            this.globalService.getAlcancesRechazo(this.form.value.IdMedidaRechazo).subscribe(result => {
                this.listAlcancesRechazo = result;
            });
        }

        //CUARENTENA
        if (this.form.value.IdMedidaRechazo === EnumIdsTwTcMedidaRechazo.CUARENTENA_IMPUESTA) {
            this.esMedidaCuarentena = true;

            this.cargarComboPaisCuarentena();
        } else {
            this.esMedidaCuarentena = false;

            this.form.patchValue({
                IdPaisCuarentena: null,
            });
        }
    }

    //Producto medida
    onSelectProductoMedidaRechazo(event: TProductoSolicitudViewModel[]) {
        this.listProductosMedidaRechazoSeleccionados = [];
        event.forEach(val => this.listProductosMedidaRechazoSeleccionados.push(val));

        this.requerirProductoMedida =
            this.listEmbalajesMedidaRechazoSeleccionados.length == 0
                ? true
                : this.listProductosMedidaRechazoSeleccionados.length > 0
                  ? this.requerirProductoMedida
                  : false;
        this.requerirEmbalajeMedida = !this.requerirProductoMedida;
    }

    //Embalaje medida
    onSelectEmbalajeMedidaRechazo(event: TwEmbalajesViewModel[]) {
        this.listEmbalajesMedidaRechazoSeleccionados = [];
        event.forEach(val => this.listEmbalajesMedidaRechazoSeleccionados.push(val));

        this.requerirEmbalajeMedida =
            this.listProductosMedidaRechazoSeleccionados.length == 0
                ? true
                : this.listEmbalajesMedidaRechazoSeleccionados.length > 0
                  ? this.requerirEmbalajeMedida
                  : false;
        this.requerirProductoMedida = !this.requerirEmbalajeMedida;
    }

    //añadir medida
    onAddMedidaRechazo() {
        //verificar que están informados los campos obligatorios, inicializamos a false
        this.form.patchValue({
            validMedidas: '',
        });

        if (this.form.value.IdMedidaRechazo != null && this.form.value.IdAlcanceRechazo != null) {
            const currentSolicitudMedida = new TwSolicitudMedidaRechazoViewModel();
            currentSolicitudMedida.IdSolicitud = this.inspeccion.IdSolicitud;
            currentSolicitudMedida.IdMedidaRechazo = this.form.value.IdMedidaRechazo;
            currentSolicitudMedida.IdAlcanceRechazo = this.form.value.IdAlcanceRechazo;

            if (this.form.value.FechaComienzoCuarentena > (this.form.value.FechaTerminacionPrevistaCuarentena || this.form.value.FechaTerminacionCuarentena)) {
                this.addErrorMessage('La Fecha Comienzo de Cuarentena no puede ser mayor que la Fecha Terminación Prevista / Fecha Terminación de Cuarentena.');
                return;
            }
            if (this.form.value.FechaTerminacionPrevistaCuarentena > this.form.value.FechaTerminacionCuarentena) {
                this.addErrorMessage('La Fecha Terminación Prevista de Cuarentena no puede ser mayor que la Fecha Terminación de Cuarentena.');
                return;
            }

            currentSolicitudMedida.FechaComienzoCuarentena = this.form.value.FechaComienzoCuarentena;
            currentSolicitudMedida.FechaTerminacionPrevistaCuarentena = this.form.value.FechaTerminacionPrevistaCuarentena;
            currentSolicitudMedida.FechaTerminacionCuarentena = this.form.value.FechaTerminacionCuarentena;
            currentSolicitudMedida.IdPaisCuarentena = this.form.value.IdPaisCuarentena;
            currentSolicitudMedida.LugarCuarentena = this.form.value.LugarCuarentena;

            //Comprobamos que no esté ya incluido
            const yaIncluido =
                this.inspeccion.TSolicitudMedidaRechazoCollection != null &&
                this.inspeccion.TSolicitudMedidaRechazoCollection.find(
                    it => it.IdMedidaRechazo == currentSolicitudMedida.IdMedidaRechazo && it.IdAlcanceRechazo == currentSolicitudMedida.IdAlcanceRechazo,
                );

            if (yaIncluido) {
                this.addErrorMessage('La Medida ya existe. Revise las Medidas añadidas');
                return;
            }

            //para poder acceder a la descripción del id seleccionado de cada combo y pintarlo en el grid de medidas añadidas
            const medidaSeleccionada = this.listMedidasRechazo.find(it => it.Id == this.form.value.IdMedidaRechazo);
            const alcanceSeleccionado = this.listAlcancesRechazo.find(it => it.Id == this.form.value.IdAlcanceRechazo);

            currentSolicitudMedida.IdMedidaRechazoDescripcion = medidaSeleccionada!.Descripcion;
            currentSolicitudMedida.IdAlcanceRechazoDescripcion = alcanceSeleccionado!.Descripcion;

            //País cuarentena
            if (this.form.value.IdPaisCuarentena != null) {
                const paisCuarentenaSeleccionado = this.listPaisCuarentena.find(it => it.Id == this.form.value.IdPaisCuarentena);
                currentSolicitudMedida.IdPaisCuarentena = this.form.value.IdPaisCuarentena;
                currentSolicitudMedida.IdPaisCuarentenaDescripcion = paisCuarentenaSeleccionado!.Descripcion;
            }

            //Gestionar si se indicaron  P R O D U C T O S  en las  M E D I D A S  del rechazo
            if (this.listProductosMedidaRechazoSeleccionados.length > 0) {
                this.listProductosMedidaRechazoSeleccionados.forEach(item => {
                    //objeto para visualizar en el grid los productos añadidos a las medidas
                    if (currentSolicitudMedida.IdProductoMedidaRechazoDescripcion == '') {
                        currentSolicitudMedida.IdProductoMedidaRechazoDescripcion = item.IdTaricProductoNombreComun;
                    } else {
                        currentSolicitudMedida.IdProductoMedidaRechazoDescripcion =
                            currentSolicitudMedida.IdProductoMedidaRechazoDescripcion + ', ' + item.IdTaricProductoNombreComun;
                    }

                    //objeto para el servidor con los productos añadidos a las medidas
                    const productoRechazoMedida = new TwProductoRechazoMedida();
                    productoRechazoMedida.IdProductoMedidaRechazo = item.Id;
                    productoRechazoMedida.IdProductoMedidaRechazoDescripcion = item.IdTaricProductoNombreComun;
                    productoRechazoMedida.IdSolicitudMedidaRechazo = currentSolicitudMedida.Id; //por asignar en servidor al guardar

                    currentSolicitudMedida.ProductoMedidaRechazoCollection.push(productoRechazoMedida);
                });
                this.form.patchValue({
                    validMedidas: true,
                });
            }

            //Gestionar si se indicaron  E M B A L A J E S  en las  M E D I D A S  del rechazo
            if (this.listEmbalajesMedidaRechazoSeleccionados.length > 0) {
                this.listEmbalajesMedidaRechazoSeleccionados.forEach(item => {
                    //objeto para visualizar en el grid los embalajes añadidos a las medidas
                    if (currentSolicitudMedida.IdEmbalajeMedidaRechazoDescripcion == '') {
                        currentSolicitudMedida.IdEmbalajeMedidaRechazoDescripcion = item.IdTaricEmbalajeDescripcion;
                    } else {
                        currentSolicitudMedida.IdEmbalajeMedidaRechazoDescripcion =
                            currentSolicitudMedida.IdEmbalajeMedidaRechazoDescripcion + ', ' + item.IdTaricEmbalajeDescripcion;
                    }

                    //objeto para el servidor con los embalajes añadidos a las medidas
                    const embalajeRechazoMedida = new TwEmbalajeRechazoMedida();
                    embalajeRechazoMedida.IdEmbalajeMedidaRechazo = item.Id;
                    embalajeRechazoMedida.IdEmbalajeMedidaRechazoDescripcion = item.IdTaricEmbalajeDescripcion;
                    embalajeRechazoMedida.IdSolicitudMedidaRechazo = currentSolicitudMedida.Id; //por asignar en servidor al guardar

                    currentSolicitudMedida.EmbalajeMedidaRechazoCollection.push(embalajeRechazoMedida);
                });
                this.form.patchValue({
                    validMedidas: true,
                });
            }

            //RDLF-->cambia la forma de introducir elementos al array para que refresque la p-tabla
            //this.inspeccion.TSolicitudMedidaRechazoCollection = [...this.inspeccion.TSolicitudMedidaRechazoCollection, currentSolicitudMedida];

            //this.removeValidators('validMedidas');
            if (this.form.value.validMedidas) {
                //verificar que están informados cuando son obligatorios
                //this.form.patchValue({
                //    validMedidas: this.detalleMeEsOrganismoNocivo ?
                //        this.form.value.OrganismoNocivo != ''
                //        && this.form.value.IdGradoContaminacion > 0
                //        && (this.esOrganismoNocivo_No_ReguladoUE ? this.form.value.IdOrganismoNocivoNoReguladoUE > 0 : true)
                //        : true
                //});

                if (this.form.value.validMedidas) {
                    this.inspeccion.TSolicitudMedidaRechazoCollection = [...this.inspeccion.TSolicitudMedidaRechazoCollection, currentSolicitudMedida];
                    this.removeValidators('validMedidas');
                } else {
                    return;
                }
            } else {
                return;
            }

            this.form.patchValue({
                IdMedidaRechazo: null,
                IdAlcanceRechazo: null,
                IdProductoMedidaRechazo: null,
                IdEmbalajeMedidaRechazo: null,
                FechaComienzoCuarentena: '',
                FechaTerminacionPrevistaCuarentena: '',
                FechaTerminacionCuarentena: '',
                IdPaisCuarentena: null,
                LugarCuarentena: '',
            });

            //una vez ya tratadas estas listas se limpian para que no afecten al añadir la siguiente medida
            this.listProductosMedidaRechazoSeleccionados = [];
            this.listEmbalajesMedidaRechazoSeleccionados = [];

            this.requerirProductoMedida = true;
            this.requerirEmbalajeMedida = false;

            //TODO rdlf: temporalmente se quita esto para ocultar el 'Destino COntrolado'
            //La decisión controlada será obligatoria dependiendo del tipo de medida seleccionada
            //if (this.inspeccion.TSolicitudMedidaRechazoCollection.find(it => it.IdMedidaRechazo == EnumIdsTwTcMedidaRechazo.DESTRUCCION
            //    || it.IdMedidaRechazo == EnumIdsTwTcMedidaRechazo.CUARENTENA_IMPUESTA
            //    || it.IdMedidaRechazo == EnumIdsTwTcMedidaRechazo.TRANSFORMACION_INDUSTRIAL)) {

            //    this.destinoControlObligatorio = true;
            //    this.addValidator('Descripcion', Validators.required);
            //}
            //else {
            //    this.destinoControlObligatorio = false;
            //    this.removeValidators('Descripcion');
            //}
        }
    }

    //eliminar medida
    onDeleteMedidaRechazo(medida: TwSolicitudMedidaRechazoViewModel) {
        //this.inspeccion.TSolicitudMedidaRechazoCollection.splice(this.inspeccion.TSolicitudMedidaRechazoCollection.indexOf(medida), 1);
        //RDLF-->cambia la forma de eliminar elementos al array para que refresque la p-tabla
        this.inspeccion.TSolicitudMedidaRechazoCollection = [
            ...this.inspeccion.TSolicitudMedidaRechazoCollection.slice(0, this.inspeccion.TSolicitudMedidaRechazoCollection.indexOf(medida)),
            ...this.inspeccion.TSolicitudMedidaRechazoCollection.slice(this.inspeccion.TSolicitudMedidaRechazoCollection.indexOf(medida) + 1),
        ];

        ////La decisión controlada será obligatoria dependiendo del tipo de medida seleccionada
        //if (this.inspeccion.TSolicitudMedidaRechazoCollection.find(it => it.IdMedidaRechazo == EnumIdsTwTcMedidaRechazo.DESTRUCCION
        //    || it.IdMedidaRechazo == EnumIdsTwTcMedidaRechazo.CUARENTENA_IMPUESTA
        //    || it.IdMedidaRechazo == EnumIdsTwTcMedidaRechazo.TRANSFORMACION_INDUSTRIAL)) {

        //    this.destinoControlObligatorio = true;
        //    this.addValidator('Descripcion', Validators.required);
        //}
        //else {
        //    this.destinoControlObligatorio = false;
        //    this.removeValidators('Descripcion');
        //}
    }

    //onSearchDestinoControl() {
    //    if (this.habilitarGuardar) {
    //        this.destinoControlPopupComponent.showDialog(null);
    //    } else {
    //        //Mostrar datos para consulta
    //        this.destinoControlPopupComponent.showDialog(this.IdDestinoControl);
    //    }
    //}

    //onAceptDialogDestinoControl(destinoControl: DestinoControlViewModel) {
    //    this.IdDestinoControl = destinoControl.Id;
    //    this.form.patchValue({
    //        //PuntoControlPopup: this.infoDestinoControl
    //        Descripcion: destinoControl.Descripcion,
    //        IdPaisDescripcion: destinoControl.IdPaisDescripcion,
    //        IdentificadorTraces: destinoControl.IdentificadorTraces,
    //        Localidad: destinoControl.Localidad,
    //        Direccion: destinoControl.Direccion,
    //    });
    //    this.removeValidators('PuntoControlPopup');
    //}

    //carga los Grados de Contaminación
    private cargarComboGradoContaminacion() {
        this.globalService.getGradoContaminacion().subscribe(result => {
            this.listGradoContaminacion = result;
        });
    }

    //carga el combo relacionado con el Organismo Nocivo No Regulado por la UE seleccionado
    private cargarComboOrganismoNocivoNoReguladoUE() {
        this.globalService.getOrganismoNocivoNoReguladoUE().subscribe(result => {
            this.listOrganismoNocivoNoReguladoUE = result;
        });
    }

    //carga el combo relacionado con el Organismo Nocivo No Especie seleccionado
    private cargarComboOrganismoNocivoNoEspecie() {
        this.globalService.getOrganismoNocivoNoEspecie().subscribe(result => {
            this.listOrganismoNocivoNoEspecie = result;
        });
    }

    //carga el combo de Países para la medida Cuarentena
    private cargarComboPaisCuarentena() {
        this.globalService.getAllPaises().subscribe(result => {
            this.listPaisCuarentena = result;
        });
    }

    onSearchOrganismoNocivo(tipoExento: string) {
        this.organismoNocivoPopupComponent.showDialog(tipoExento, false);
    }

    onAceptDialogOrganismoNocivo(organismoNocivo: WOrganismosNocivosExtendedViewModel) {
        this.idOrganismoNocivo = organismoNocivo.Id; //id para enviar a servidor
        this.esOrganismoNocivo_No_ReguladoUE = !organismoNocivo.RegulatedUe; //si es NO ReguladoUE se visualiza otro combo más
        this.esOrganismoNocivo_No_Especie = organismoNocivo.NoEspecie; //si es SI NoEspecie se visualiza otro combo más

        this.form.patchValue({
            OrganismoNocivo: organismoNocivo.Code + ' - ' + organismoNocivo.FullName, //descripción para mostrar en pantalla
        });

        if (this.esOrganismoNocivo_No_ReguladoUE) {
            this.cargarComboOrganismoNocivoNoReguladoUE();
        }

        //TODO. Este criterio está aún por verificar por parte del CAU
        if (organismoNocivo.NoEspecie) {
            this.cargarComboOrganismoNocivoNoEspecie();
        }
    }

    onSubmit() {
        if (this.requerirObservaciones) {
            this.addValidator('Observaciones', Validators.required);
        } else {
            this.removeValidators('Observaciones');
            this.requerirObservaciones = false;
        }
        const decision = this.decisionLetterToId();
        //@adua: eliminar estas validaciones (tarea 144306)
        //if (decision === EnumIdsTwTcDecisionInspeccion.NO_PROCEDE) {
        //    this.requerirIdentidad = false;
        //    this.requerirFisica = false;
        //}
        //RDLF:25/10/24 eliminar estas validaciones (tarea 144306)
        //if (this.requerirIdentidad || this.requerirFisica) {
        //    this.addValidator('validIdentidadFisicaRequerida', Validators.required);
        //} else {
        //    this.removeValidators('validIdentidadFisicaRequerida');
        //    this.requerirIdentidad = false;
        //    this.requerirFisica = false;
        //}

        let selectedMatriculas: string[];

        if (this.form.value.matriculasInsp.length > 0) {
            selectedMatriculas = this.form.value.matriculasInsp
                .map((v: any, i: any) => (v ? this.matriculasInsp[i].Matricula : null))
                .filter((v: any) => v !== null);
            //Validamos que haya mercancia posicionada, si no es un Traslado y se va a efectuar la física, y no es PREDUA
            if (selectedMatriculas.length == 0 && !this.EsTraslado && !this.EsAeropuerto && this.SeEfectuaIdentidadFisica && !this.EsPredua) {
                this.addValidator('validPosicionamiento', Validators.required);
            } else {
                this.removeValidators('validPosicionamiento');
            }
        }

        //Validamos Medidas y Motivos si es RECHAZO
        if (this.form.value.IdDecision == EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR) {
            //TIPO INSPECCIÓN RECHAZO
            if (
                this.form.value.TipoInspSupervisionPuestoInsp === true ||
                this.form.value.TipoInspControlSeguimientoNoSintomas === true ||
                this.form.value.TipoInspControlSeguimientoSiSintomas === true
            ) {
                this.form.patchValue({
                    validTipoInspeccionRechazo: true,
                });
                this.removeValidators('validTipoInspeccionRechazo');
            } else {
                this.addValidator('validTipoInspeccionRechazo', Validators.required);
            }
            //MEDIDAS
            if (this.inspeccion.TSolicitudMedidaRechazoCollection.length > 0) {
                this.removeValidators('validMedidas');
            } else {
                this.addValidator('validMedidas', Validators.required);
            }
            //MOTIVOS
            if (this.inspeccion.TSolicitudMotivoRechazoCollection.length > 0) {
                this.removeValidators('validMotivos');
            } else {
                this.addValidator('validMotivos', Validators.required);
            }
        } else {
            this.removeValidators('validMedidas');
            this.removeValidators('validMotivos');
        }

        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos de la inspección');
            this.habilitarEdicion = true;
            return;
        }

        this.visibilitySpinner = true;

        const inspeccion = new TInspeccionViewModel();

        inspeccion.Documental = this.Documental;
        inspeccion.SeEfectuaIdentidadFisica = this.SeEfectuaIdentidadFisica;
        inspeccion.Identidad = this.Identidad;
        inspeccion.Fisica = this.Fisica;
        inspeccion.IdUsuarioDocumental = this.IdInspector;
        inspeccion.IdUsuarioIdentidad = this.IdInspector;
        inspeccion.IdUsuarioFisica = this.IdInspector;
        inspeccion.Observaciones = this.form.value.Observaciones;
        inspeccion.IdDecision = this.decisionLetterToId();

        //Si la Decisión es NO_PROCEDE guardo el IdUsuarioNoProcede
        if (inspeccion.IdDecision === EnumIdsTwTcDecisionInspeccion.NO_PROCEDE || inspeccion.IdDecision === EnumIdsTwTcDecisionInspeccion.NO_APTO_POR_HIGIENE) {
            inspeccion.IdUsuarioNoProcede = this.IdInspector;
        }
        //Si la Decision es Rechazo guardo las medidas y motivos
        if (inspeccion.IdDecision == EnumIdsTwTcDecisionInspeccion.RECHAZAR) {
            inspeccion.TwInspeccionRechazo = new TwInspeccionRechazoViewModel();
            inspeccion.TwInspeccionRechazo.IdDestinoControl = this.IdDestinoControl;
            inspeccion.TwInspeccionRechazo.FechaRechazo = this.form.value.FechaMedidasRechazo;
            inspeccion.TwInspeccionRechazo.TipoInspSupervisionPuestoInsp = this.form.value.TipoInspSupervisionPuestoInsp;
            inspeccion.TwInspeccionRechazo.TipoInspControlSeguimientoNoSintomas = this.form.value.TipoInspControlSeguimientoNoSintomas;
            inspeccion.TwInspeccionRechazo.TipoInspControlSeguimientoSiSintomas = this.form.value.TipoInspControlSeguimientoSiSintomas;
            inspeccion.TwInspeccionRechazo.ObservacionesRechazo = this.form.value.ObservacionesMedidasRechazo;

            inspeccion.TSolicitudMedidaRechazoCollection = this.inspeccion.TSolicitudMedidaRechazoCollection;
            inspeccion.TSolicitudMotivoRechazoCollection = this.inspeccion.TSolicitudMotivoRechazoCollection;

            inspeccion.DocumentosAdjuntosRechazoIdsCollection = this.documentosAttachedRechazoUserCheck;
        }

        inspeccion.EsPredua = this.EsPredua;
        inspeccion.FechaLlegada = this.FechaLlegada;
        //inspeccion.IdEstadoSolicitud = this.IdEstadoSolicitud;

        //RDLF: 23 / 10 / 24 de momento los preduas cargan los equipamientos igual que los no preduas(144302)
        //Si es PREDUA no se envian equipamientos
        //if (!this.EsPredua) {
        inspeccion.TSolicitudEquipamientoCollection = this.inspeccion.TSolicitudEquipamientoCollection;

        if (inspeccion.TSolicitudEquipamientoCollection != null) {
            inspeccion.TSolicitudEquipamientoCollection.forEach(y => {
                //1º Pongo toda la coleccion a false por defecto
                y.Inspeccion = false;
                if (selectedMatriculas.includes(y.Matricula)) {
                    y.Inspeccion = true;
                }
            });
        }
        //}

        if (this.inspeccion.FechaDocumental != null) {
            inspeccion.FechaDocumental = this.inspeccion.FechaDocumental;
        }

        inspeccion.IdSolicitud = this.IdSolicitud;

        if (this.editMode) {
            this.submitEdition(inspeccion);
        } else {
            this.submitCreation(inspeccion);
        }
    }

    private submitCreation(inspeccion: TInspeccionViewModel): void {
        if (inspeccion.IdDecision != null && inspeccion.IdDecision != EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE) {
            this.notifyAsyncRequest();
        }

        this.inspeccionesService.createInspeccion(inspeccion).subscribe({
            next: res => {
                // (emarti69) Bug #143877 resuelto: En el core se hace la misma validación (if (inspeccion.IdDecision != null && inspeccion.IdDecision != EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE)) para saber si se tiene que invocar al método SubmitOnDemand del controlador. Esto se hace desde el core para evitar que el método SubmitOnDemand no se haga si el usuario decide cambiar de pestaña antes de que haya terminado el proceso de la misma.
                this.procesarRespuesta(res);
            },
            error: error => {
                this.catchServerError(error);
                if (inspeccion.IdDecision != null && inspeccion.IdDecision != EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE) {
                    this.notifyAsyncResponse();
                }
                this.visibilitySpinner = false;

                const errorFechaLlegada = error?.error?.find(findErrorFechaLlegada);
                function findErrorFechaLlegada(arrayErrors: { key: string }) {
                    return arrayErrors.key === 'fecha_llegada';
                }
                if (errorFechaLlegada != null) {
                    this.addErrorMessage('La Fecha de Inspección debe ser posterior a la Fecha de Llegada');
                }
            },
        });
    }

    private submitEdition(inspeccion: TInspeccionViewModel): void {
        if (inspeccion.IdDecision != null && inspeccion.IdDecision != EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE) {
            this.notifyAsyncRequest();
        }

        this.inspeccionesService.editInspeccion(inspeccion).subscribe({
            next: res => {
                this.procesarRespuesta(res);
            },
            error: error => {
                this.catchServerError(error);
                if (inspeccion.IdDecision != null && inspeccion.IdDecision != EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE) {
                    this.notifyAsyncResponse();
                }
                this.visibilitySpinner = false;

                const errorFechaLlegada = error?.error?.find(findErrorFechaLlegada);
                function findErrorFechaLlegada(arrayErrors: { key: string }) {
                    return arrayErrors.key === 'fecha_llegada';
                }
                if (errorFechaLlegada != null) {
                    this.addErrorMessage('La Fecha de Inspección debe ser posterior a la Fecha de Llegada');
                }
            },
        });
    }

    private procesarRespuesta(res: any): void {
        if (res?.Status != 1 && res?.Status != 2) {
            this.addSuccessMessage('Inspección guardada correctamente');
        }

        this.visibilitySpinner = false;

        if (res?.Status == 1) {
            this.notificacionService.addSuccessMessage(res?.Description);
            this.Init(false);
            this.notifyAsyncResponse();
        } else if (res?.Status == 2) {
            this.notifyAsyncRequest();
            this.notificacionService.addErrorMessage(res?.Description);
            this.Init(false);
            this.notifyAsyncResponse();
        } else {
            this.ngOnInit();
        }
    }

    private decisionIdToLetter(IdDecision: number | null): EnumIdsTwTcDecisionInspeccionLetter | null {
        let decisionLetter = null;

        switch (IdDecision) {
            case EnumIdsTwTcDecisionInspeccion.ACEPTAR:
                decisionLetter = EnumIdsTwTcDecisionInspeccionLetter.ACEPTAR;
                break;
            case EnumIdsTwTcDecisionInspeccion.RECHAZAR:
                decisionLetter = EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR;
                break;
            case EnumIdsTwTcDecisionInspeccion.NO_PROCEDE:
                decisionLetter = EnumIdsTwTcDecisionInspeccionLetter.NO_PROCEDE;
                break;
            case EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE:
                decisionLetter = EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR_PARCIALMENTE;
                break;
            case EnumIdsTwTcDecisionInspeccion.NO_APTO_POR_HIGIENE:
                decisionLetter = EnumIdsTwTcDecisionInspeccionLetter.NO_APTO_POR_HIGIENE;
                break;
            default:
                decisionLetter = null;
                break;
        }
        return decisionLetter;
    }

    private decisionLetterToId() {
        const IdDecisionLetra = this.form.controls['IdDecision'].value;
        let IdDecision = null;
        switch (IdDecisionLetra) {
            case EnumIdsTwTcDecisionInspeccionLetter.ACEPTAR:
                IdDecision = EnumIdsTwTcDecisionInspeccion.ACEPTAR;
                break;
            case EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR:
                IdDecision = EnumIdsTwTcDecisionInspeccion.RECHAZAR;
                break;
            case EnumIdsTwTcDecisionInspeccionLetter.NO_PROCEDE:
                IdDecision = EnumIdsTwTcDecisionInspeccion.NO_PROCEDE;
                break;
            case EnumIdsTwTcDecisionInspeccionLetter.RECHAZAR_PARCIALMENTE:
                IdDecision = EnumIdsTwTcDecisionInspeccion.RECHAZAR_PARCIALMENTE;
                break;
            case EnumIdsTwTcDecisionInspeccionLetter.NO_APTO_POR_HIGIENE:
                IdDecision = EnumIdsTwTcDecisionInspeccion.NO_APTO_POR_HIGIENE;
                break;
            default:
                IdDecision = null;
                break;
        }
        return IdDecision;
    }

    private notifyAsyncRequest() {
        const async = new AsyncInfoRequestViewModel();
        async.Caption = this.CodigoSolicitud;
        async.Id = this.IdSolicitud;
        async.Description = 'Enviando Traces/Aduanas';
        this.asyncInfoService.notifyRequest(async);
    }

    private notifyAsyncResponse() {
        const async = new AsyncInfoResponseViewModel();

        async.Id = this.IdSolicitud;
        this.asyncInfoService.notifyResponse(async);
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.IdSolicitud]);
    }

    get canNoAptoPorHigiene(): boolean {
        if (!this.solicitud?.TPuntoInspeccion) {
            // Necesitamos éste objeto cargado, para que las siguientes condiciones se evalúen.
            return false;
        }
        const accionVisible = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.RADIOBUTTON_NO_APTO_POR_HIGIENE).Visible;
        //RDLF 13/05/25: para que el solicitante visualice la Decisión (174506)
        if (!this.esInspector) {
            return (
                accionVisible &&
                this.habilitarRechazarDecision &&
                this.EsPredua &&
                this.productoUnico &&
                this.solicitudPuntoInspecccionHabilitadoSanidadExterior
            );
        } else {
            return (
                accionVisible &&
                this.habilitarRechazarDecision &&
                this.EsPredua &&
                this.productoSanidadExt &&
                this.productoUnico &&
                this.solicitudPuntoInspecccionHabilitadoSanidadExterior
            );
        }
    }

    private get productoSanidadExt(): boolean {
        return this.mostrarFrSanidadExt && this.frSanidadExtInsp?.length > 0;
    }

    private get productoUnico(): boolean {
        return this.numeroProductos === 1;
    }

    /**
     * Que el PIF (o ya lo llaman más PCF) de la solicitud (Campo IdPuntoInspeccion en Tsolicitud) en sus datos en TpuntoInspeccion tenga el campo HabilitadoSanidadExterior a valor true
     */
    private get solicitudPuntoInspecccionHabilitadoSanidadExterior(): boolean {
        return this.solicitud?.TPuntoInspeccion?.HabilitadoSanidadExterior;
    }

    get disableSaving(): boolean {
        return !this.habilitarGuardar || this.visibilityBtnRechazoParcial;
    }

    get disableRevision(): boolean {
        return !this.habilitarEdicion || this.visibilityBtnRechazoParcial;
    }

    ngOnDestroy(): void {
        if (this.solicitudCargada$ !== undefined && !this.solicitudCargada$.closed) {
            this.solicitudCargada$.complete();
            this.solicitudCargada$.unsubscribe();
        }
        if (this.solicitud$ !== undefined && !this.solicitud$.closed) {
            this.solicitud$.unsubscribe();
        }
    }
}
